import React, {useEffect, useRef, useState, Fragment, useImperativeHandle, forwardRef} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import {
	// BOOKING_TYPE_BULK,
	// BOOKING_TYPE_PARCEL,
	CAPTURE_IMAGE_OF_ARTICLE,
	CAPTURE_IMAGE_OF_SENDER,
	CARRIER_TYPE_INSIDE_DICKEY,
	CARRIER_TYPE_ROOF_TOP,
	CONSTRAINT_BOOKING_DESC_MAX_LENGTH,
	CONSTRAINT_EMAIL_MAX_LENGTH,
	CONSTRAINT_USERNAME_MAX_LENGTH,
	COUNTER_DELIVERY,
	DOOR_DELIVERY,
	IDENTITY_MANDATORY_FROM_SHIPMENT_VALUE,
	INVALID_MOBILE_NO,
	PRODUCT_TYPE_VEGETABLE,
	REGEX_EMAIL,
	REGEX_MOBILE_NO,
	// ROUTE_NOT_FOUND_MESSAGE,
	RUPEE_SYMBOl,
	// UPI_PAYMENT,
	VEHICLE_TYPE_DGT,
	VEHICLE_TYPE_DICKEY,
	VEHICLE_TYPE_ROOFTOP,
} from '../helpers/constants.js';
import Identity from '../common/Identity.jsx';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InputAdornment from '@mui/material/InputAdornment';
import {
	dataURIToBlob,
	roundOffBookingWeight,
	scrollIntoView,
	scrollToErrorElement,
	validateIdentity,
} from '../helpers/utilities';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import '../payment/Payment.css';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import FormGroup from '@mui/material/FormGroup';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import {IconButton, Link as MUILink} from '@mui/material';
// import WeighingHelper from '../helpers/WeighingHelper';
import FareDetails from './FareDetails.jsx';
import CustomerAddress from './CustomerAddress.jsx';
import noimage from '../assets/images/noimage.jpeg';
import ImageCapture from '../graphics/ImageCapture.jsx';
import {Tab, Tabs} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import BookingConfirmationDialog from '../common/BookingConfirmationDialog.jsx';
import {withStyles} from '@mui/styles';
import {useStyles} from '../styles/commercials';
import Snackbars from '../common/Snackbar.jsx';
import {Link} from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import CustomerActiveCounter from './CustomerActiveCounter.jsx';
import ServiceInterceptor from '../apis/Service.jsx';
import {fetchConfigurations} from '../actions/postActions.js';
import {useDispatch} from 'react-redux';
import './BookingForm.css';
import {CUSTOMER_DATA} from '../actions/types.js';
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
var count = 0;
const MAX_WEIGHT_FOR_DGT = 14000;
const MAX_WEIGHT_FOR_DICKEY = 1200;
const MAX_WEIGHT_FOR_ROOFTOP = 1200;
const weightInfoFormObj = [
	{
		heading: 'Weight Info (Please click on Add button to calculate weight and transport charges)',
		column: null,
		type: 'divider_button',
		defaultValue: '',
		isRequired: false,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Weight Calculation',
		column: 'carrierTypeId',
		type: 'ajax',
		defaultValue: '152',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/PARCEL_CARRIERS',
		ajaxData:
			'[{"id":152,"code":"INNSIDE_BUS","name":"INSIDE BUS"},{"id":153,"code":"INSIDE_DICKY","name":"INSIDE DICKY"},{"id":151,"code":"ROOF_TOP","name":"ROOF TOP"}]',
		viewColumn: 'carrierTypeName',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Product',
		column: 'cargoTypeId',
		type: 'ajax',
		defaultValue: '1012',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/PARCEL_PRODUCT_TYPES',
		ajaxData:
			'[{"id":1006,"code":"AGRI PRODUCT","name":"AGRI PRODUCT"},{"id":1007,"code":"ALUMINIUM","name":"ALUMINIUM"},{"id":1008,"code":"AQUA PRODUCTS","name":"AQUA PRODUCTS"},{"id":1009,"code":"BANNERS","name":"BANNERS"},{"id":1010,"code":"CLOTH","name":"CLOTH"},{"id":1000,"code":"COCONUTS","name":"COCONUTS"},{"id":1005,"code":"ELECTRONIC GOODS","name":"ELECTRONIC GOODS"},{"id":1011,"code":"FERTILIZER","name":"FERTILIZER"},{"id":1001,"code":"FLOWERS","name":"FLOWERS"},{"id":1012,"code":"GENERAL","name":"GENERAL"},{"id":1004,"code":"PACKED SEAFOOD","name":"STEEL/PLASTIC"},{"id":1013,"code":"RICE","name":"RICE"},{"id":1002,"code":"STEEL/PLASTIC","name":"STEEL/PLASTIC"},{"id":1003,"code":"VEGETABLES","name":"VEGETABLES"}]',
		viewColumn: 'cargoType',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Sub Category',
		column: 'subProductTypeId',
		type: 'ajax',
		defaultValue: '634',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/PARCEL_PRODUCT_TYPES',
		ajaxData:
			'[{"id":634,"code":"AGRI PRODUCT","name":"AGRI PRODUCT","parentCode":"GENERAL"},{"id":635,"code":"ALUMINIUM","name":"ALUMINIUM","parentCode":"GENERAL"},{"id":636,"code":"AQUA PRODUCTS","name":"AQUA PRODUCTS","parentCode":"GENERAL"},{"id":637,"code":"BANNERS","name":"BANNERS","parentCode":"GENERAL"},{"id":638,"code":"BATTERY","name":"BATTERY","parentCode":"GENERAL"},{"id":639,"code":"BLOOD SAMPLE","name":"BLOOD SAMPLE","parentCode":"GENERAL"},{"id":640,"code":"BOOKS","name":"BOOKS","parentCode":"GENERAL"},{"id":641,"code":"CHILLI POWDER","name":"CHILLI POWDER","parentCode":"GENERAL"},{"id":642,"code":"CLOTH","name":"CLOTH","parentCode":"GENERAL"},{"id":643,"code":"COCONUT","name":"COCONUT","parentCode":"GENERAL"},{"id":644,"code":"COURIER","name":"COURIER","parentCode":"GENERAL"},{"id":645,"code":"DENTAL","name":"DENTAL","parentCode":"GENERAL"},{"id":647,"code":"ELECTRICAL/ELECTRONIC","name":"ELECTRICAL/ELECTRONIC","parentCode":"GENERAL"},{"id":648,"code":"FANCY ITEMS","name":"FANCY ITEMS","parentCode":"GENERAL"},{"id":649,"code":"FERTILIZER","name":"FERTILIZER","parentCode":"GENERAL"},{"id":650,"code":"FISH","name":"FISH","parentCode":"GENERAL"},{"id":651,"code":"FOOD","name":"FOOD","parentCode":"GENERAL"},{"id":652,"code":"GENERAL","name":"GENERAL","parentCode":"GENERAL"},{"id":653,"code":"GIFT","name":"GIFT","parentCode":"GENERAL"},{"id":654,"code":"MEDICAL","name":"MEDICAL","parentCode":"GENERAL"},{"id":655,"code":"MOTOR","name":"MOTOR","parentCode":"GENERAL"},{"id":656,"code":"OIL","name":"OIL","parentCode":"GENERAL"},{"id":657,"code":"OPTICAL","name":"OPTICAL","parentCode":"GENERAL"},{"id":658,"code":"OTHER","name":"OTHER","parentCode":"GENERAL"},{"id":633,"code":"OTHERS","name":"OTHERS","parentCode":"GENERAL"},{"id":659,"code":"PAINT","name":"PAINT","parentCode":"GENERAL"},{"id":660,"code":"PAPER ROLLS","name":"PAPER ROLLS","parentCode":"GENERAL"},{"id":661,"code":"PESTICIDES","name":"PESTICIDES","parentCode":"GENERAL"},{"id":662,"code":"PHOTO ALBUM","name":"PHOTO ALBUM","parentCode":"GENERAL"},{"id":663,"code":"RICE","name":"RICE","parentCode":"GENERAL"},{"id":664,"code":"SAREES","name":"SAREES","parentCode":"GENERAL"},{"id":665,"code":"SEED","name":"SEED","parentCode":"GENERAL"},{"id":666,"code":"SHOES","name":"SHOES","parentCode":"GENERAL"},{"id":667,"code":"SILK","name":"SILK","parentCode":"GENERAL"},{"id":668,"code":"SPARES","name":"SPARES","parentCode":"GENERAL"},{"id":669,"code":"STATIONERY","name":"STATIONERY","parentCode":"GENERAL"},{"id":670,"code":"SWEET","name":"SWEET","parentCode":"GENERAL"},{"id":671,"code":"TOOLS","name":"TOOLS","parentCode":"GENERAL"},{"id":672,"code":"TYRES","name":"TYRES","parentCode":"GENERAL"},{"id":673,"code":"YARN","name":"YARN","parentCode":"GENERAL"}]',
		viewColumn: 'subProductTypeId',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		subCategoryAjaxData: '',
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Type Of Piece',
		column: 'pieceTypeId',
		type: 'dropdown',
		defaultValue: '400',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/CARGO_PIECE_TYPES',
		ajaxData: '[{"id":401,"code":"BOX","name":"BOX"},{"id":400,"code":"NOS","name":"NOS"}]',
		viewColumn: 'cargoType',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Actual Weight',
		column: 'actualweight',
		type: 'text_field',
		defaultValue: '',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		pattren: '/d{1,2}',
		numeric: true,
		max: '99',
		multiValue: false,
	},
	{
		heading: 'No. of pieces',
		column: 'unit',
		type: 'text_field',
		defaultValue: '1',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '3',
		numeric: false,
		multiValue: false,
		validationObj: {inputType: 'number'},
	},
	{
		heading: 'Total Weight',
		column: 'totalweight',
		type: 'text_field',
		defaultValue: '0',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: true,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
		shrinkInput: true,
	},
];
const CourierWeightInfoFormObj = [
	{
		heading: 'Weight Info (Please click on Add button to calculate weight and transport charges)',
		column: null,
		type: 'divider_button',
		defaultValue: '',
		isRequired: false,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Weight Calculation',
		column: 'carrierTypeId',
		type: 'ajax',
		defaultValue: '152',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/PARCEL_CARRIERS',
		ajaxData:
			'[{"id":152,"code":"INNSIDE_BUS","name":"INSIDE BUS"},{"id":153,"code":"INSIDE_DICKY","name":"INSIDE DICKY"},{"id":151,"code":"ROOF_TOP","name":"ROOF TOP"}]',
		viewColumn: 'carrierTypeName',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Product',
		column: 'cargoTypeId',
		type: 'ajax',
		defaultValue: '1012',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/PARCEL_PRODUCT_TYPES',
		ajaxData:
			'[{"id":1006,"code":"AGRI PRODUCT","name":"AGRI PRODUCT"},{"id":1007,"code":"ALUMINIUM","name":"ALUMINIUM"},{"id":1008,"code":"AQUA PRODUCTS","name":"AQUA PRODUCTS"},{"id":1009,"code":"BANNERS","name":"BANNERS"},{"id":1010,"code":"CLOTH","name":"CLOTH"},{"id":1000,"code":"COCONUTS","name":"COCONUTS"},{"id":1005,"code":"ELECTRONIC GOODS","name":"ELECTRONIC GOODS"},{"id":1011,"code":"FERTILIZER","name":"FERTILIZER"},{"id":1001,"code":"FLOWERS","name":"FLOWERS"},{"id":1012,"code":"GENERAL","name":"GENERAL"},{"id":1004,"code":"PACKED SEAFOOD","name":"STEEL/PLASTIC"},{"id":1013,"code":"RICE","name":"RICE"},{"id":1002,"code":"STEEL/PLASTIC","name":"STEEL/PLASTIC"},{"id":1003,"code":"VEGETABLES","name":"VEGETABLES"}]',
		viewColumn: 'cargoType',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Type Of Piece',
		column: 'pieceTypeId',
		type: 'ajax',
		defaultValue: '400',
		isRequired: true,
		ajaxUrl: 'http://localhost:8080/oprs-api/ajax/getMasterCodebyType/CARGO_PIECE_TYPES',
		ajaxData: '[{"id":401,"code":"BOX","name":"BOX"},{"id":400,"code":"NOS","name":"NOS"}]',
		viewColumn: 'cargoType',
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: null,
		numeric: false,
		multiValue: false,
	},
	{
		heading: 'Actual Weight',
		column: 'actualweight',
		type: 'text_field',
		defaultValue: '',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		pattren: '/d{1,2}',
		numeric: true,
		max: '99',
		multiValue: false,
	},
	{
		heading: 'No. of pieces',
		column: 'unit',
		type: 'text_field',
		defaultValue: '1',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '3',
		numeric: false,
		multiValue: false,
		validationObj: {inputType: 'number'},
	},
	{
		heading: 'Total Weight',
		column: 'totalweight',
		type: 'text_field',
		defaultValue: '0',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: true,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
		shrinkInput: true,
	},
];
const volumetricForm = [
	{
		heading: 'Length (cms)',
		column: 'length',
		type: 'text_field',
		defaultValue: '1',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
		validationObj: {inputType: 'number'},
	},
	{
		heading: 'Breadth (cms)',
		column: 'breadth',
		type: 'text_field',
		defaultValue: '1',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
		validationObj: {inputType: 'number'},
	},
	{
		heading: 'Height (cms)',
		column: 'height',
		type: 'text_field',
		defaultValue: '1',
		isRequired: true,
		ajaxUrl: null,
		ajaxData: null,
		viewColumn: null,
		tabList: null,
		disabled: false,
		customized: false,
		display: '',
		maxlength: '',
		numeric: false,
		multiValue: false,
		validationObj: {inputType: 'number'},
	},
];

let timeoutIns = null;

const MAX_ACTUAL_WEIGHT = 50;
const MAX_ENVELOPE_ACTUAL_WEIGHT = 999;
const volumetricCarrierTypeIds = [151, 153];
let fetchPlaceTimeoutIns = null;

const CustomerBookingForm = forwardRef(({classes, currentStep}, ref) => {
	const dispatch = useDispatch();
	const [isLocationEnabled, setLocationEnabled] = useState(false);
	const [bookingCountChangeCounter, setBookingTypeChangeCounter] = useState(0);
	const [isFetchingLocationsList, setIsFetchingLocationsList] = useState(false);
	const [isUserConsented, setIsUserConsented] = useState(true);
	const [packaging, setPackaging] = useState({
		isCoverPackaging: false,
		isPlasticPackaging: false,
	});
	const [acceptedTermsAndConditions, setAcceptedTermsAndConditions] = useState(false);
	const [formValues, setFormValues] = useState({
		//source
		sourceState: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		sourceDistrict: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		sourceCounter: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		sourceLocation: {
			value: '',
			selectedItem: null,
			errorMessage: null,
			distance: null,
		},
		//destination
		destinationState: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		// destinationDistrict: {
		//     value: '',
		//     selectedItem: {},
		//     errorMessage: null
		// },
		destinationCounter: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		// destinationLocation: {
		//     value: '',
		//     selectedItem: null,
		//     errorMessage: null,
		//     distance: null,
		// },
		dropTypeId: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		// from: { value: "" },
		fromMobile: {value: ''},
		fromName: {value: ''},
		fromEmail: {value: ''},
		fromGstin: {value: ''},
		pickUpDate: {value: '', errorMessage: null},
		area: {
			value: '',
			selectedItem: {},
			errorMessage: null,
		},
		senderAddress: {
			houseNo: {
				value: '',
				errorMessage: null,
			},
			area: {
				value: '',
				errorMessage: null,
				// ignore: true,
			},
			landmark: {
				value: '',
				errorMessage: null,
			},
			city: {
				value: '',
				errorMessage: null,
			},
			pincode: {
				value: '',
				errorMessage: null,
				// ignore: true,
			},
		},
		identityTypeId: {value: '', selectedItem: null},
		identityNumber: {value: ''},

		//reciever
		// to: { value: "" },
		toMobile: {value: ''},
		toName: {value: ''},
		toEmail: {value: ''},
		toGstin: {value: ''},
		receiverAddress: {
			houseNo: {
				value: '',
				errorMessage: null,
			},
			area: {
				value: '',
				errorMessage: null,
				// ignore: true,
			},
			landmark: {
				value: '',
				errorMessage: null,
			},
			city: {
				value: '',
				errorMessage: null,
			},
			pincode: {
				value: '',
				errorMessage: null,
				// ignore: true,
			},
		},
		totalWeight: {value: ''},
		standard: {value: ''},
		general: {value: ''},
		shipmentValue: {value: ''},
		paymentType: {value: ''},
		paymentMode: {value: ''},
		desc: {value: ''},
	});
	const [isCourier, setIsCourier] = useState(false);
	const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
	const [paymentOptionsError, setPaymentOptionsError] = useState(null);
	let formSubmitInProgress = false;
	// const weighingHelper = new WeighingHelper();
	const [state, setState] = useState({
		stackbarType: 'success',
		shipmentAlert: false,
		statesList: [],
		subCategoryOptions: [],
		editWeightInfoIndex: -1,
		tabIndex: 0,
		carrierTypeList: [],
		cargoTypeList: [],
		subCategoryAjaxData: [],
		pieceTypeList: [],
		unit: '',
		isWeighingMachine: false,
		pieceTypeListAjax: '[]',
		weightInfo: [],
		enableDoorDelivery: false,
		addWeightIndex: 0,
		showBooking: false,
		nearestPoint: {
			counter: null,
			distance: null,
		},
		isLoading: false,
		areaPincodeDetails: [],
		areaPincodeList: [],
		sourceAreaPincodeDetails: [],
		sourcePincodeList: [],
		articleImage: null,
		captureImageFor: null,
		// clearBotton: false,
		// toClearBotton: false,
		articleImageSelection: false,
		showRetryPopup: false,
		saveBookingResponse: '',
		loadPrint: false,
		isItemAddStart: false,
		showOverView: false,
		stockNo: null,
		bookingRes: null,
		bookingID: '',
		originalWeight: 0,
		pincodesList: [],
		pincodeSourceList: [],
		slotList: [],
		availId: null,
	});
	const [isMobile, setIsMobile] = useState(false);
	const [bookingTypeMode, setBookingTypeMode] = useState('1');
	const [districtList, updateDistrictList] = useState({
		originalDistrict: [],
		copyDistrict: [],
	});
	const [prevFormValue, setPrevFormValue] = useState(null);
	const [CounterList, updateCounterList] = useState([]);
	const [PlaceList, updatePlaceList] = useState([]);
	const [filteredAreaList, updateDestinationCounterList] = useState([]);
	const [sourceFilteredAreaList, updateSourceCounterList] = useState([]);
	const [stateParams, setAddParams] = useState({
		addBooking: false,
		addParams: [],
	});
	const [fareRes, updateFareRes] = useState(null);
	const [snackbar, updateSnackBar] = useState(null);
	const [bookingConfig, setBookingConfig] = useState(null);
	const [clearReceiverAddress, setClearReceiverAddress] = useState(false);
	const [identityTypeList, setIdentityTypeList] = useState(null);
	const [jsonData, setJsonData] = useState({
		dropTypeJson: null,
	});
	//eslint-disable-next-line
	const [errors, setErrors] = useState({});
	const articleImageUploadRef = useRef();
	const [transhipmentState, setTranshipmentState] = useState({
		distanceResponse: '',
		transshipmentCount: 0,
		transshipment: [],
		transshipmentList: null,
		disableTransshipment: false,
		endPlaceSelectedItem: {},
		errors: {},
		showBooking: false,
		carrierTypeId: null,
		fareResponse: '',
		show: true,
	});
	const [alertMessage, setAlertMessage] = useState(null);
	const [canShowActiveCounters, setCanShowActiveCounters] = useState(false);
	const [selectedButton, setSelectedButton] = useState(null);

	useImperativeHandle(ref, () => ({
		validateSenderInfo: () => {
			let newFormValues = {...formValues};
			const emailRegex = new RegExp(REGEX_EMAIL);
			let isValid = true;
			['senderAddress', 'fromName', 'fromEmail', 'identityTypeId', 'identityNumber', 'pickUpDate'].forEach(
				(key) => {
					if (key === 'senderAddress') {
						Object.keys(newFormValues.senderAddress).forEach((key) => {
							if (!newFormValues.senderAddress[key].value && !newFormValues.senderAddress[key].ignore) {
								newFormValues.senderAddress[key].errorMessage = `This field is required!`;
								isValid = false;
							}
						});
					} else {
						if (newFormValues[key] && !newFormValues[key].value) {
							newFormValues[key].errorMessage = 'This field is required!';
							isValid = false;
						}
					}
				}
			);
			if (newFormValues.fromEmail.value && emailRegex.test(newFormValues.fromEmail.value) === false) {
				newFormValues.fromEmail.errorMessage = 'Invalid email address!';
				isValid = false;
			}
			if (newFormValues.identityNumber && newFormValues.identityNumber.errorMessage) {
				isValid = false;
			}
			if (!isValid) {
				setFormValues(newFormValues);
			} else {
				dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
			}
			if (!state.availId) {
				showSnackBar('error', 'Please Select The Slot');
				isValid = false;
			}
			return isValid;
		},
		validateReceiverInfo: () => {
			let newFormValues = {...formValues};
			const emailRegex = new RegExp(REGEX_EMAIL);
			let isValid = true;
			['receiverAddress', 'toName', 'toMobile'].forEach((key) => {
				if (key === 'receiverAddress') {
					Object.keys(newFormValues.receiverAddress).forEach((key) => {
						if (!newFormValues.receiverAddress[key].value && !newFormValues.receiverAddress[key].ignore) {
							newFormValues.receiverAddress[key].errorMessage = `This field is required!`;
							isValid = false;
						}
					});
				} else {
					if (newFormValues[key] && !newFormValues[key].value) {
						newFormValues[key].errorMessage = 'This field is required!';
						isValid = false;
					}
				}
			});
			if (newFormValues.toEmail.value && emailRegex.test(newFormValues.toEmail.value) === false) {
				newFormValues.toEmail.errorMessage = 'Invalid email address!';
				isValid = false;
			}
			if (newFormValues.toMobile && newFormValues.toMobile.errorMessage) {
				isValid = false;
			}
			if (!isValid) {
				setFormValues(newFormValues);
			} else {
				dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
			}
			return isValid;
		},
		validateWeightInfo: () => {
			if (state.weightInfo.length <= 0) alert('Please Add weight');
			if (state.weightInfo.length > 0) {
				let totalWeightItem = 0;
				state.weightInfo.forEach((item) => (totalWeightItem += Number(item.totalWeight)));
				dispatch({
					type: CUSTOMER_DATA,
					data: {...formValues, ...state, bookingTypeMode: bookingTypeMode, totalWeightItem},
				});
			}
			return state.weightInfo.length > 0;
		},
		validateBookingInfo: () => {
			let newFormValues = {...formValues};
			let isValid = true;
			['shipmentValue', 'desc'].forEach((key) => {
				if (newFormValues[key] && !newFormValues[key].value) {
					newFormValues[key].errorMessage = 'This field is required!';
					isValid = false;
				}
			});
			if (acceptedTermsAndConditions === false) {
				alert('Please accept terms and conditions');
				isValid = false;
			}
			if (!fareRes) {
				alert('Please Click On Get Fares Button');
				isValid = false;
			}
			if (!isValid) {
				setFormValues(newFormValues);
			} else {
				dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
			}
			return isValid;
		},
		validateArticeImage: () => {
			if (!state.articleImage) {
				alert('Please upload the article image');
			}
			return Boolean(state.articleImage);
		},
		OnConfirmLogistics: () => {
			handleSubmit();
		},
	}));
	const showPaymentOptions = Boolean(
		bookingConfig &&
			// eslint-disable-next-line
			((bookingConfig.paymentCollectType != '1' &&
				bookingConfig.miniPickFareCollect !== undefined &&
				parseInt(bookingConfig.miniPickFareCollect) > 0) ||
				// eslint-disable-next-line
				(bookingConfig.paymentCollectType && bookingConfig.paymentCollectType == '1' && fareRes))
	);
	useEffect(() => {
		dispatch(fetchConfigurations());
		fetchConfiguration();
		fetchHeaders();
		// fetchBookingPlaces();
		fetchStatesList();
		fetchDistrictList();
		fetchBookingConfiguration();
		//eslint-disable-next-line
		formSubmitInProgress = false;
		if (formValues) {
			const updatedFormValues = {...formValues};
			updatedFormValues.carrierTypeId = {};
			updatedFormValues.carrierTypeId.value = 'GENERAL';
			updatedFormValues.carrierTypeId.errorMessage = null;
			updatedFormValues.carrierTypeId.selectedItem = {
				id: 152,
				code: 'GENERAL',
				name: 'GENERAL',
			};
			updatedFormValues.cargoTypeId = {};
			updatedFormValues.cargoTypeId.value = 'GENERAL';
			updatedFormValues.cargoTypeId.errorMessage = null;
			updatedFormValues.cargoTypeId.selectedItem = {
				id: 1012,
				code: 'GENERAL',
				name: 'GENERAL',
			};
			setFormValues(updatedFormValues);
		}
		let customerObj = JSON.parse(localStorage.getItem('customerDetails'));
		if (customerObj) {
			const updatedFormValues = {...formValues};
			updatedFormValues.fromName.value =
				(customerObj && customerObj.customerAddress && customerObj.customerAddress.customerName) || '';
			updatedFormValues.fromMobile.value =
				(customerObj && customerObj.customerAddress && customerObj.customerAddress.mobileNumber) || '';
			updatedFormValues.fromEmail.value =
				(customerObj && customerObj.customerAddress && customerObj.customerAddress.email) || '';
			updatedFormValues.senderAddress.houseNo.value =
				(customerObj && customerObj.customerAddress && customerObj.customerAddress.address1) || '';
		}
		if (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1)
			setIsMobile(true);
		dispatch({
			type: CUSTOMER_DATA,
			data: {...formValues, ...state, bookingTypeMode: bookingTypeMode, totalWeightItem: 0},
		});
		return () => {
			timeoutIns && clearTimeout(timeoutIns);
		};
	}, []);

	useEffect(() => {
		const updatedFormValues = {...formValues};
		updatedFormValues.showBooking = false;
		setFormValues(updatedFormValues);
		//eslint-disable-next-line
	}, [isUserConsented, acceptedTermsAndConditions]);

	useEffect(() => {
		if (bookingCountChangeCounter > 0) {
			fetchConfiguration();
			fetchHeaders();
			fetchStatesList();
			fetchDistrictList();
			fetchBookingConfiguration();
			//eslint-disable-next-line
			formSubmitInProgress = false;
			if (formValues) {
				const updatedFormValues = {...formValues};
				updatedFormValues.carrierTypeId = {};
				updatedFormValues.carrierTypeId.value = 'GENERAL';
				updatedFormValues.carrierTypeId.errorMessage = null;
				updatedFormValues.carrierTypeId.selectedItem = {
					id: bookingTypeMode === '0' ? 154 : 152,
					code: 'GENERAL',
					name: 'GENERAL',
				};
				updatedFormValues.cargoTypeId = {};
				updatedFormValues.cargoTypeId.value = 'GENERAL';
				updatedFormValues.cargoTypeId.errorMessage = null;
				updatedFormValues.cargoTypeId.selectedItem = {
					id: bookingTypeMode === '0' ? 155 : 1012,
					code: 'GENERAL',
					name: 'GENERAL',
				};
				setFormValues(updatedFormValues);
			}
		}
	}, [bookingCountChangeCounter]);
	// useEffect(() => dispatch({type: CUSTOMER_DATA, data: formValues}), [formValues]);
	useEffect(() => {
		resetBookingForm(true);
		setIsCourier(false);
		setBookingTypeChangeCounter((counter) => ++counter);
		updateFareRes(null);
		setFormValues((prev) => ({...prev, showBooking: false, fareReq: null}));
		if (bookingTypeMode === '0') {
			setState((prev) => ({...prev, unit: 1}));
		}
		//eslint-disable-next-line
	}, [bookingTypeMode]);
	useEffect(() => {
		if (!isLocationEnabled && prevFormValue !== null && prevFormValue !== formValues.sourceState.value) {
			const updatedFormValues = {...formValues};
			updatedFormValues.sourceDistrict.value = '';
			updatedFormValues.sourceDistrict.selectedItem = {};
			updatedFormValues.sourceDistrict.errorMessage = null;
			updatedFormValues.sourceCounter.value = '';
			updatedFormValues.sourceCounter.selectedItem = {};
			updatedFormValues.sourceCounter.errorMessage = null;
			updatedFormValues.sourceCounter.displayName = '';
			setFormValues(updatedFormValues);
		}
		setPrevFormValue(formValues.sourceState.value);
		//eslint-disable-next-line
	}, [formValues.sourceState.value, prevFormValue]);
	const onSetStateParams = (addParams) => {
		let carrierTypeList = null,
			carrierTypeListAjax = '[]';
		let cargoTypeList = null,
			cargoTypeListAjax = '[]';
		let subCategoryList = null,
			subCategoryAjax = '[]',
			subCategoryAjaxData = '[]';
		let pieceTypeList = null,
			pieceTypeListAjax = '[]';
		addParams.forEach((item) => {
			switch (item.column) {
				case 'carrierTypeId': {
					carrierTypeListAjax = item.ajaxData;
					carrierTypeList = JSON.parse(item.ajaxData);
					weightInfoFormObj[1].defaultValue = item.defaultValue;
					CourierWeightInfoFormObj[1].defaultValue = item.defaultValue;
					break;
				}
				case 'cargoTypeId': {
					cargoTypeListAjax = item.ajaxData;
					cargoTypeList = JSON.parse(item.ajaxData);
					weightInfoFormObj[2].defaultValue = item.defaultValue;
					CourierWeightInfoFormObj[2].defaultValue = item.defaultValue;
					subCategoryAjaxData = item.subCategoryAjaxData;
					break;
				}
				case 'subProductTypeId': {
					subCategoryAjax = item.ajaxData;
					subCategoryList = JSON.parse(item.ajaxData);
					weightInfoFormObj[3].defaultValue = item.defaultValue;
					break;
				}
				case 'pieceTypeId': {
					pieceTypeListAjax = item.ajaxData;
					pieceTypeList = JSON.parse(item.ajaxData);
					weightInfoFormObj[4].defaultValue = item.defaultValue;
					CourierWeightInfoFormObj[4].defaultValue = item.defaultValue;

					break;
				}
				default: {
					break;
				}
			}
		});
		weightInfoFormObj[1].ajaxData = carrierTypeListAjax;
		weightInfoFormObj[2].ajaxData = cargoTypeListAjax;
		weightInfoFormObj[3].ajaxData = subCategoryAjax;
		weightInfoFormObj[4].ajaxData = pieceTypeListAjax;
		CourierWeightInfoFormObj[1].ajaxData = carrierTypeListAjax;
		CourierWeightInfoFormObj[2].ajaxData = cargoTypeListAjax;
		CourierWeightInfoFormObj[4].ajaxData = pieceTypeListAjax;
		const subCategoryAjaxDataParsed = JSON.parse(subCategoryAjaxData || '[]');
		let prd;
		if (bookingTypeMode === '0') {
			prd =
				(cargoTypeList &&
					cargoTypeList.find((i) => i.id.toString() === CourierWeightInfoFormObj[2].defaultValue)) ||
				{};
		} else {
			prd =
				(cargoTypeList && cargoTypeList.find((i) => i.id.toString() === weightInfoFormObj[2].defaultValue)) ||
				{};
		}
		const subCategoryOptions = getSubCategoryListByProductCode(prd.code, subCategoryAjaxDataParsed);
		setState((prev) => ({
			...prev,
			carrierTypeList,
			cargoTypeList,
			subCategoryList,
			pieceTypeList,
			subCategoryOptions,
			subCategoryAjaxData: subCategoryAjaxDataParsed,
		}));
	};

	useEffect(() => {
		if (stateParams.addParams.length > 0) {
			for (let i = 0; i < stateParams.addParams.length; i++) {
				if (stateParams.addParams[i].column === 'dropTypeId') {
					let dropTypeList = JSON.parse(stateParams.addParams[i].ajaxData);
					setJsonData((prev) => {
						return {
							...prev,
							dropTypeJson: dropTypeList,
							dropTypeSelectedItem: dropTypeList[0],
						};
					});
					// const updatedFormValues = { ...formValues }
					// updatedFormValues.dropTypeId.value = dropTypeList[1].id
					// updatedFormValues.dropTypeId.selectedItem = dropTypeList[1]
					setFormValues((prev) => ({
						...prev,
						dropTypeId: {
							errorMessage: null,
							value: dropTypeList[1].id,
							selectedItem: dropTypeList[1],
						},
					}));
				}
				if (stateParams.addParams[i].column === 'paymentMode') {
					let paymentModeList = JSON.parse(stateParams.addParams[i].ajaxData);
					setJsonData((prev) => ({
						...prev,
						paymentModeJson: paymentModeList,
					}));
					setFormValues((prev) => ({
						...prev,
						paymentMode: {
							errorMessage: null,
							value: paymentModeList[0].id,
							selectedItem: paymentModeList[0],
						},
					}));
				}
				if (stateParams.addParams[i].column === 'paymentType') {
					let paymentTypeList = JSON.parse(stateParams.addParams[i].ajaxData);
					setJsonData((prev) => ({
						...prev,
						paymentTypeJson: paymentTypeList,
					}));
					setFormValues((prev) => ({
						...prev,
						paymentType: {
							value: paymentTypeList[0].id,
							errorMessage: null,
							selectedItem: paymentTypeList[0],
						},
					}));
				}
				setState((prev) => ({...prev, errors}));
			}
		}
		//eslint-disable-next-line
	}, [stateParams.addParams]);

	useEffect(() => {
		if (formValues.sourceLocation.value && formValues.destinationCounter.value && formValues.sourceCounter.value) {
			getPlacesDistance(
				formValues.sourceCounter.value,
				formValues.destinationCounter.value,
				'pickupDistance',
				formValues.sourceLocation.distance
			);
		}
		if (isLocationEnabled && formValues.destinationCounter.value && formValues.sourceCounter.value) {
			getPlacesDistance(
				formValues.sourceCounter.value,
				formValues.destinationCounter.value,
				'pickupDistance',
				formValues.sourceLocation.distance
			);
		}
		//eslint-disable-next-line
	}, [formValues.destinationCounter.value, formValues.sourceCounter.value]);

	//Resetting the formvalues if the value of source state changes
	useEffect(() => {
		if (formValues.sourceLocation.value === '' || formValues.sourceState.value) {
			['sourceState', 'sourceCounter', 'sourceDistrict'].forEach((item) => {
				formValues[item].value = '';
				formValues[item].errorMessage = null;
				formValues[item].selectedItem = {};
				if (item === 'sourceCounter') {
					formValues[item].displayName = '';
				}
			});
			updateCounterList([]);
		}
		if (formValues.sourceLocation.value === '') {
			['landmark', 'city'].forEach((item) => {
				formValues.senderAddress[item].value = '';
				formValues.senderAddress[item].errorMessage = null;
			});
		}
		//eslint-disable-next-line
	}, [formValues.sourceLocation.value]);
	//Resetting the formvalues if the value of pincode changes
	useEffect(() => {
		if (!formValues.receiverAddress.pincode.value || formValues.receiverAddress.pincode.value.length === 0) {
			['destinationCounter', 'destinationState'].forEach((item) => {
				formValues[item].value = '';
				formValues[item].errorMessage = null;
				formValues[item].selectedItem = {};
			});
			formValues.receiverAddress.area.value = '';
			formValues.receiverAddress.area.selectedItem = {};
			updateDestinationCounterList([]);
			setTranshipmentState({
				distanceResponse: '',
				transshipmentCount: 0,
				transshipment: [],
				transshipmentList: null,
				disableTransshipment: false,
				endPlaceSelectedItem: {},
				errors: {},
				showBooking: false,
				carrierTypeId: null,
				fareResponse: '',
				show: true,
			});
		}
		//eslint-disable-next-line
	}, [formValues.receiverAddress.pincode.value]);
	useEffect(() => {
		if (formValues.senderAddress.pincode.value.length === 0) {
			['sourceCounter', 'sourceState', 'pickUpDate'].forEach((item) => {
				if (item === 'sourceCounter') {
					formValues[item].value = '';
					formValues[item].displayName = '';
					formValues[item].errorMessage = null;
					formValues[item].selectedItem = {};
				} else {
					formValues[item].value = '';
					formValues[item].errorMessage = null;
					formValues[item].selectedItem = {};
				}
			});
			formValues.senderAddress.area.value = '';
			formValues.senderAddress.area.selectedItem = {};
			updateSourceCounterList([]);
			setTranshipmentState({
				distanceResponse: '',
				transshipmentCount: 0,
				transshipment: [],
				transshipmentList: null,
				disableTransshipment: false,
				endPlaceSelectedItem: {},
				errors: {},
				showBooking: false,
				carrierTypeId: null,
				fareResponse: '',
				show: true,
			});
			setState((prev) => ({...prev, slotList: []}));
		}
		//eslint-disable-next-line
	}, [formValues.senderAddress.pincode.value]);
	useEffect(() => {
		if (
			formValues &&
			formValues.senderAddress &&
			formValues.senderAddress.area &&
			formValues.senderAddress.area.selectedItem &&
			formValues.senderAddress.area.selectedItem.placeId
		) {
			const updatedFormValues = {...formValues};
			updatedFormValues.sourceCounter.value =
				formValues.senderAddress && formValues.senderAddress.area.selectedItem.placeId;
			updatedFormValues.sourceCounter.selectedItem = formValues.senderAddress.area.selectedItem;
			updatedFormValues.sourceCounter.displayName = formValues.senderAddress.area.selectedItem.placeName;
			updatedFormValues.sourceCounter.errorMessage = null;
			updatedFormValues.sourceState.value =
				formValues.senderAddress && formValues.senderAddress.area.selectedItem.stateCOde;
			updatedFormValues.sourceState.selectedItem = formValues.senderAddress.area.selectedItem;
			updatedFormValues.sourceState.errorMessage = null;
			showSnackBar('success', 'Counter updated!');
			setFormValues(updatedFormValues);
			fetchSlot(new Date());
		}
		//eslint-disable-next-line
	}, [formValues.senderAddress.area.selectedItem]);
	useEffect(() => {
		if (formValues.pickUpDate.value) {
			const updatedFormValues = {...formValues};
			updatedFormValues.fareReq = null;
			updatedFormValues.showBooking = false;
			setState((prev) => ({...prev, availId: null}));
			setFormValues(updatedFormValues);
			updateFareRes(null);
			setSelectedButton(null);
		}
		// eslint-disable-next-line
	}, [formValues.pickUpDate.value]);
	useEffect(() => {
		if (
			formValues.destinationCounter.selectedItem &&
			formValues.destinationCounter.selectedItem.isCargoDelivery === '1'
		)
			setState((prev) => ({...prev, enableDoorDelivery: true}));
		if (
			formValues.destinationCounter.selectedItem &&
			formValues.destinationCounter.selectedItem.isCargoDelivery === '0'
		)
			setState((prev) => ({...prev, enableDoorDelivery: false}));
		setTranshipmentState({
			distanceResponse: '',
			transshipmentCount: 0,
			transshipment: [],
			transshipmentList: null,
			disableTransshipment: false,
			endPlaceSelectedItem: {},
			errors: {},
			showBooking: false,
			carrierTypeId: null,
			fareResponse: '',
			show: true,
		});
		//eslint-disable-next-line
	}, [formValues.destinationCounter.value]);
	useEffect(() => {
		if (state.areaPincodeDetails.length > 0) {
			const uniquePincodesArray = state.pincodesList.filter((pincode) =>
				pincode.includes(formValues.receiverAddress.pincode.value)
			);
			setState((prev) => ({...prev, areaPincodeList: uniquePincodesArray}));
		}
		if (formValues.receiverAddress.pincode.value && formValues.receiverAddress.pincode.value.length === 6) {
			const filteredAreaCode = state.areaPincodeDetails.filter(
				(area) => area.pincode === formValues.receiverAddress.pincode.value
			);
			updateDestinationCounterList(filteredAreaCode);
		}
		//eslint-disable-next-line
	}, [formValues.receiverAddress.pincode.value]);
	useEffect(() => {
		if (state.sourceAreaPincodeDetails.length > 0) {
			const uniquePincodesArray = state.pincodeSourceList.filter((pincode) =>
				pincode.includes(formValues.senderAddress.pincode.value)
			);
			setState((prev) => ({...prev, sourcePincodeList: uniquePincodesArray}));
		}
		if (formValues.senderAddress.pincode.value.length === 6) {
			const filteredAreaCode = state.sourceAreaPincodeDetails.filter(
				(area) => area.pincode === formValues.senderAddress.pincode.value
			);
			updateSourceCounterList(filteredAreaCode);
		}
		//eslint-disable-next-line
	}, [formValues.senderAddress.pincode.value]);
	useEffect(() => {
		if (!formValues.receiverAddress.pincode.value && !formValues.receiverAddress.area.value) {
			updateDestinationCounterList(state.areaPincodeDetails);
		}
		//eslint-disable-next-line
	}, [formValues.receiverAddress.pincode.value, formValues.receiverAddress.area.value]);
	useEffect(() => {
		if (!formValues.senderAddress.pincode.value && !formValues.senderAddress.area.value) {
			updateSourceCounterList(state.sourceAreaPincodeDetails);
		}
		//eslint-disable-next-line
	}, [formValues.senderAddress.pincode.value, formValues.senderAddress.area.value]);
	useEffect(() => {
		if (state.availId) {
			const updatedFormValues = {...formValues};
			updatedFormValues.fareReq = null;
			updatedFormValues.showBooking = false;
			setFormValues(updatedFormValues);
			updateFareRes(null);
		}
		// eslint-disable-next-line
	}, [state.availId]);

	// All api call are below
	const fetchBookingConfiguration = () => {
		const params = {
			bookingFrom: '1',
		};
		ServiceInterceptor(
			'/api/customer',
			'/customer/getConfiguration',
			'POST',
			params,
			(res) => {
				if (res && res.error === false) {
					if (res.searchMapEnabled === false) {
						setLocationEnabled(true);
						fetchSourceAreas();
					}
					fetchPincodeAreas(res.searchMapEnabled === false);
					setBookingConfig(res);
					if (res.loginText && alertMessage !== '') setAlertMessage(res.loginText);
					if (res.paymentOptionList.length > 0) {
						setSelectedPaymentOption(res.paymentOptionList[0]);
					}
					// setState((prev) => ({ ...prev, configBooking: res }))
					timeoutIns = setTimeout(() => {
						setAlertMessage('');
					}, 10000);
				}
			},
			(err) => {}
		);
	};
	const fetchHeaders = () => {
		// this.setState({ addBooking: false, addParams: [] })
		setAddParams({addBooking: false, addParams: []});
		var requestObject = {superUserId: '1622116236204', bookingFrom: '1'};
		ServiceInterceptor(
			'/api/customer',
			`${bookingTypeMode === '0' ? '/booking/getAddHeader' : '/booking/courier/getAddHeader'}`,
			'POST',
			requestObject,
			(res) => {
				if (res && res.addHeaders) {
					setAddParams((prev) => ({
						...prev,
						addBooking: true,
						addParams: res.addHeaders,
						response: res,
					}));
					onSetStateParams(res.addHeaders);
				}
			},
			(err) => {}
		);
	};

	const fetchConfiguration = () => {
		// this.setState({ addBooking: false, addParams: [] })
		setAddParams({addBooking: false, addParams: []});
		ServiceInterceptor(
			'/api/customer',
			'/getConfiguration',
			'GET',
			null,
			(res) => {
				if (res) {
					setIdentityTypeList(res.identityTypeList);
				}
			},
			(err) => {}
		);
	};
	const fetchPincodeAreas = (dontSetSenderAreas) => {
		ServiceInterceptor('/api/customer', '/getareaPincode', 'GET', null, (res) => {
			if (res.status === '0' && res.message === 'Success') {
				const uniquePincodes = new Set();
				res.areas.forEach((item) => {
					const pincode = item.pincode;
					uniquePincodes.add(pincode);
				});
				let uniquePincodesArray = Array.from(uniquePincodes);
				setState((prev) => ({
					...prev,
					areaPincodeDetails: res.areas,
					pincodesList: uniquePincodesArray,
					pincodeSourceList: !dontSetSenderAreas ? uniquePincodesArray : prev.pincodeSourceList,
					sourceAreaPincodeDetails: !dontSetSenderAreas ? res.areas : prev.sourceAreaPincodeDetails,
				}));
				updateDestinationCounterList(res.areas);
				if (!dontSetSenderAreas) updateSourceCounterList(res.areas);
			}
		});
	};
	const onLocationClick = (typeofLocation) => {
		setLocationEnabled(typeofLocation === 'manualLocation');
		const updatedFormValues = {...formValues};
		const arrayToClear = ['sourceCounter', 'sourceState', 'senderAddress'];
		arrayToClear.forEach((item) => {
			if (item === 'senderAddress') {
				updatedFormValues[item].area = {
					value: '',
					errorMessage: null,
					ignore: true,
				};
				updatedFormValues[item].pincode = {
					value: '',
					errorMessage: null,
					ignore: true,
				};
			} else if (item === 'sourceCounter') {
				updatedFormValues[item] = {
					value: '',
					selectedItem: {},
					errorMessage: null,
					displayName: '',
				};
			} else {
				updatedFormValues[item] = {
					value: '',
					selectedItem: {},
					errorMessage: null,
				};
			}
		});
		setFormValues(updatedFormValues);
	};
	const fetchStatesList = () => {
		ServiceInterceptor(
			'/api/customer',
			'/getCargoStateCodes',
			'POST',
			{},
			(res) => {
				if (res.staeCodesList && res.staeCodesList.length > 0) {
					// updateStatesList(res.staeCodesList);
					setState((prev) => ({...prev, statesList: res.staeCodesList}));
				}
			},
			(err) => {}
		);
	};
	const onInfoClick = () => {
		setCanShowActiveCounters(true);
	};
	const fetchDistrictList = () => {
		ServiceInterceptor(
			'/api/customer',
			'/getDistrictList',
			'POST',
			{},
			(res) => {
				if (res.message === 'Success' && res.districtList.length > 0) {
					updateDistrictList((prev) => ({
						...prev,
						originalDistrict: res.districtList,
					}));
				}
			},
			(err) => {}
		);
	};
	// const fetchBookingPlaces = () => {
	// 	ServiceInterceptor(
	// 		'/api/customer',
	// 		'/getBookingPlaces',
	// 		'POST',
	// 		{},
	// 		(res) => {
	// 			if (res.bookingToPlaces && res.bookingToPlaces.length > 0) {
	// 				updateBookingPlace(res.bookingToPlaces);
	// 			}
	// 		},
	// 		(err) => {}
	// 	);
	// };
	const fetchCounterList = (id, counter) => {
		const payload = {
			districtId: id,
			latitude: formValues.sourceLocation.selectedItem.lat,
			longitude: formValues.sourceLocation.selectedItem.lon,
		};
		ServiceInterceptor(
			'/api/customer',
			'/getCounterList',
			'POST',
			payload,
			(res) => {
				if (res.status === '0' && res.message === 'Success' && res.bookingToPlaces.length > 0) {
					const updatedFormValues = {...formValues};
					updatedFormValues.sourceCounter.value = res.bookingToPlaces[0].placeId;
					updatedFormValues.sourceCounter.displayName = res.bookingToPlaces[0].placeCode;
					setFormValues(updatedFormValues);
					showSnackBar('success', 'Counter updated!');
				} else {
					showSnackBar('error', res.message);
					const updatedFormValues = {...formValues};
					updatedFormValues[counter].value = '';
					updatedFormValues[counter].selectedItem = {};
					setFormValues(updatedFormValues);
					if (counter === 'destinationCounter') {
						updateDestinationCounterList([]);
					}
					if (counter === 'sourceCounter') {
						updateCounterList([]);
						updateSourceCounterList([]);
					}
				}
			},
			(err) => {}
		);
	};
	const fetchSourceAreas = () => {
		let url = '/customer/getSourceAreas';
		ServiceInterceptor('/api/customer', `${url}`, 'GET', null, (res) => {
			if (res.status === '0' && res.message === 'Success') {
				const uniquePincodes = new Set();
				res.areas.forEach((item) => {
					const pincode = item.pincode;
					uniquePincodes.add(pincode);
				});
				let uniquePincodesArray = Array.from(uniquePincodes);
				setState((prev) => ({
					...prev,
					pincodeSourceList: uniquePincodesArray,
					sourceAreaPincodeDetails: res.areas,
				}));
				updateSourceCounterList(res.areas);
			}
		});
	};
	const showSnackBar = (type = 'success', message) => {
		if (!message) return;

		updateSnackBar({type, message});
		setTimeout(() => {
			hideSnackBar();
		}, 3000);
	};
	const fetchPlaceList = (event, value, location) => {
		setFormValues((state) => ({
			...state,
			[location]: {
				...state[location],
				value: value,
			},
		}));

		if (fetchPlaceTimeoutIns) clearTimeout(fetchPlaceTimeoutIns);
		fetchPlaceTimeoutIns = setTimeout(() => fetchPlacesList(location, value), 200);
	};

	const fetchPlacesList = (location, value) => {
		setIsFetchingLocationsList(true);
		fetch(`https://nominatim.openstreetmap.org/search?q=${value}&format=json&countrycodes=IN`)
			.then((res) => res.json())
			.then((place) => {
				if (!place || !place.length) return;
				if (location === 'sourceLocation') updatePlaceList(place);
			})
			.finally(() => {
				setIsFetchingLocationsList(false);
			});
	};

	const fetchPincodeList = (event, value, name) => {
		if ((!value && !event) || (event.eventPhase && event.eventPhase === 1)) return;
		let updatedFormValues = {...formValues};
		if (name === 'destination') {
			if ((!value && !event) || (event.eventPhase && event.eventPhase === 1)) return;
			updatedFormValues.receiverAddress.area.value = '';
			updatedFormValues.destinationCounter.displayName = '';
			updatedFormValues.destinationCounter.value = '';
			updatedFormValues.destinationCounter.errorMessage = null;
			updatedFormValues.destinationCounter.selectedItem = {};
			updatedFormValues.destinationState.value = '';
			updatedFormValues.destinationState.errorMessage = null;
			updatedFormValues.destinationState.selectedItem = {};
			updatedFormValues.receiverAddress.pincode.value = value;
			updatedFormValues.receiverAddress.pincode.errorMessage = null;
		}
		if (name === 'source') {
			updatedFormValues.senderAddress.area.value = '';
			updatedFormValues.sourceCounter.displayName = '';
			updatedFormValues.sourceCounter.value = '';
			updatedFormValues.sourceCounter.errorMessage = null;
			updatedFormValues.sourceCounter.selectedItem = {};
			updatedFormValues.sourceState.value = '';
			updatedFormValues.sourceState.errorMessage = null;
			updatedFormValues.sourceState.selectedItem = {};
			updatedFormValues.senderAddress.pincode.value = value;
			updatedFormValues.senderAddress.pincode.errorMessage = null;
		}
		setFormValues(updatedFormValues);
	};
	const getPlacesDistance = function (startPlaceId, endPlaceId, location, distance) {
		console.log(startPlaceId, endPlaceId, distance, 'getPlacesDistance');
		if (!endPlaceId) return;
		const reqObj = {
			startPlaceId: startPlaceId,
			endPlaceId: endPlaceId,
			pickupDistance: distance,
			dropDistance: 0,
			selectAutoTranshipment: '1',
		};
		const {transshipment} = transhipmentState;
		const referenceRouteIdList = [{startPlaceID: startPlaceId, endPlaceID: endPlaceId}];
		transshipment &&
			Array.isArray(transshipment) &&
			transshipment.length > 0 &&
			transshipment.forEach((item) => {
				const endLocationId = referenceRouteIdList[referenceRouteIdList.length - 1].endPlaceID;
				referenceRouteIdList[referenceRouteIdList.length - 1].endPlaceID = item.value;
				referenceRouteIdList.push({
					startPlaceID: item.value,
					endPlaceID: endLocationId,
				});
			});
		reqObj.referenceRouteIdList = referenceRouteIdList;
		ServiceInterceptor(
			'/api/customer',
			'/booking/getDistance',
			'POST',
			reqObj,
			(res) => {
				if (res && res.isFixedRoute && res.isFixedRoute === '1') {
					if (res.referenceRouteIdList && res.referenceRouteIdList.length > 1) {
						const transshipmentInfo = [];
						for (let i = 1; i < res.referenceRouteIdList.length; i++) {
							transshipmentInfo.push({
								value: res.referenceRouteIdList[i].startPlaceID,
								selectedItem: {
									id: res.referenceRouteIdList[i].startPlaceID,
									name: res.referenceRouteIdList[i].fromPlaceName,
								},
							});
						}
						setTranshipmentState((prev) => ({
							...prev,
							transshipment: transshipmentInfo,
							transshipmentCount: transshipmentInfo.length,
							disableTransshipment: true,
						}));
					}
					setTranshipmentState((prev) => ({...prev, distanceResponse: res}));
				} else if (res && res.totalDistance && res.totalDistance !== 0) {
					setTranshipmentState((prev) => ({
						...prev,
						distanceResponse: res,
						disableTransshipment: false,
					}));
				} else {
					showSnackBar('error', 'No Route Found!', 12000);
					scrollIntoView('button#add-transshipment');
				}
			},
			(err) => {}
		);
	};
	// const fetchTransshipmentPoints = () => {
	//     const startPlaceId = formValues.sourceCounter.value
	//     const endPlaceId = formValues.destinationCounter.value
	//     // const cargoTypeId = formValues.productType.value  can be removed
	//     let hasErrors = false;
	//     const { errors, transshipmentList, transshipmentCount } = transhipmentState;
	//     if (!endPlaceId) {
	//         errors.endPlaceId = "This field is required!";
	//         hasErrors = true;
	//     }
	//     // if (!cargoTypeId) { can be removed
	//     //     errors.cargoTypeId = "This field is required!";
	//     //     hasErrors = true;
	//     // }

	//     if (hasErrors) {
	//         alert("Please fill the form correctly!");
	//         return setTranshipmentState({ errors }, scrollToErrorElement);
	//     } else if (transshipmentList && transshipmentList.length > 0 && transshipmentCount > 0) {
	//         return setTranshipmentState((prev) => ({ ...prev, transshipmentCount: transshipmentCount + 1 }));
	//     };
	//     updateFareRes(null)
	//     setTranshipmentState((prev) => ({ ...prev, fetchingTransshipment: true, }));
	//     setFormValues((prev) => ({ ...prev, showBooking: false, }))
	//     const reqObj = {
	//         startPlaceId,
	//         endPlaceId,
	//         ProductTYpeId: null
	//     };
	//     ServiceInterceptor("/api/customer", "/getTranshipmentPoints", "POST", reqObj,
	//         res => {
	//             if (res.transhipmentList && res.transhipmentList.length > 0) {
	//                 setTranshipmentState((prev) => ({ ...prev, transshipmentList: res.transhipmentList, fetchingTransshipment: false, transshipmentCount: 1 }));
	//             } else {
	//                 resetTransshipmentPoints();
	//                 showSnackBar("error", res.message || "No transshipment list found!");
	//             }
	//         },
	//         err => {
	//             resetTransshipmentPoints();
	//             showSnackBar("error", err.message || "Error occurred while fetching transshipment list!");
	//         }
	//     );
	//     updateFareRes(null);
	//     setFormValues((prev) => ({ ...prev, showBooking: false }))
	//     setTranshipmentState((prev) => ({ ...prev, }))
	// }
	//All functionalites are below
	const handleAutoCompleteSelect = (name, value, selectedItem) => {
		updateFareRes(null);
		setFormValues((prev) => ({...prev, showBooking: false, fareReq: null}));
		if (!name) return;
		if (name === 'area') {
			const updatedFormValues = {...formValues};
			updatedFormValues.receiverAddress.area.selectedItem = selectedItem;
			updatedFormValues.receiverAddress.area.errorMessage = null;
			updatedFormValues.receiverAddress.pincode.errorMessage = null;

			if (!formValues.receiverAddress.pincode.value || formValues.receiverAddress.pincode.value.length !== 6) {
				updatedFormValues.receiverAddress.pincode.value = (selectedItem && selectedItem.pincode) || '';
			}
			updatedFormValues.destinationCounter.value =
				(formValues.receiverAddress.area &&
					formValues.receiverAddress.area.selectedItem &&
					formValues.receiverAddress.area.selectedItem.placeId) ||
				'';
			updatedFormValues.destinationCounter.selectedItem = formValues.receiverAddress.area.selectedItem;
			updatedFormValues.destinationCounter.errorMessage = null;
			updatedFormValues.destinationState.value =
				(formValues.receiverAddress.area &&
					formValues.receiverAddress.area.selectedItem &&
					formValues.receiverAddress.area.selectedItem.stateCOde) ||
				'';
			updatedFormValues.destinationState.selectedItem = formValues.receiverAddress.area.selectedItem;
			updatedFormValues.destinationState.errorMessage = null;
			updatedFormValues.dropTypeId.value =
				// eslint-disable-next-line
				selectedItem?.isCargoDelivery == '0' ? COUNTER_DELIVERY : DOOR_DELIVERY;
			updatedFormValues.dropTypeId.selectedItem =
				// eslint-disable-next-line
				selectedItem?.isCargoDelivery == '0' ? jsonData.dropTypeJson[0] : jsonData.dropTypeJson[1];
			setJsonData((prev) => ({
				...prev,
				dropTypeSelectedItem:
					// eslint-disable-next-line
					selectedItem?.isCargoDelivery == '0' ? jsonData.dropTypeJson[0] : jsonData.dropTypeJson[1],
			}));
			setFormValues(updatedFormValues);
		}
		if (name === 'sourceArea') {
			const updatedFormValues = {...formValues};
			updatedFormValues.senderAddress.area.selectedItem = selectedItem;
			updatedFormValues.senderAddress.area.errorMessage = null;
			updatedFormValues.senderAddress.pincode.errorMessage = null;

			if (!formValues.senderAddress.pincode.value) {
				updatedFormValues.senderAddress.pincode.value = (selectedItem && selectedItem.pincode) || '';
			}
			setFormValues(updatedFormValues);
		}
		if (name === 'dropTypeId' && selectedItem?.id === DOOR_DELIVERY) {
			setJsonData((prev) => ({...prev, dropTypeSelectedItem: selectedItem}));
			fetchDoorDeliveryPincodes();
		}
		const updatedFormValues = {...formValues};
		if (!updatedFormValues[name] || typeof updatedFormValues[name] !== 'object') updatedFormValues[name] = {};
		updatedFormValues[name].value = value;
		updatedFormValues[name].errorMessage = null;
		updatedFormValues[name].selectedItem = selectedItem;
		updatedFormValues.fareReq = null;
		updatedFormValues.showBooking = false;

		if (name === 'sourceState') {
			const filteredDistrict = districtList.originalDistrict.filter((item) => {
				return item.stateCode === value;
			});
			if (filteredDistrict.length > 0) {
				updateDistrictList((prev) => ({
					...prev,
					copyDistrict: filteredDistrict,
				}));
			} else {
				updatedFormValues['sourceDistrict'].selectedItem = {};
			}
		}
		if (name === 'sourceDistrict') {
			fetchCounterList(value, 'sourceCounter');
		}

		if (name === 'sourceLocation') {
			// const updatedFormValues = {...formValues}
			// const pincode = Number(value.display_name.match(/[0-9]{6}/)[0])
			// updatedFormValues.senderAddress.pincode.value = pincode||''
			if (
				formValues.destinationCounter.errorMessage &&
				formValues.sourceCounter.value &&
				formValues.sourceLocation.value
			) {
				const updatedFormValues = {...formValues};
				updatedFormValues['destinationCounter'].errorMessage = null;
				setFormValues(updatedFormValues);
			}
			// setFormValues(updatedFormValues)
		}
		if ('cargoTypeId' === name && selectedItem) {
			const {errors} = state;
			if (
				selectedItem &&
				selectedItem.id === PRODUCT_TYPE_VEGETABLE &&
				transhipmentState.distanceResponse &&
				transhipmentState.distanceResponse.totalDistance &&
				transhipmentState.distanceResponse.totalDistance > 500
			) {
				return alert('For vegetables, distance should not be greater than 500');
			}
			errors.shipmentValue = null;

			setState((prev) => ({
				...prev,
				subProductTypeId: null,
				subCategoryOptions: getSubCategoryListByProductCode(selectedItem.code, state.subCategoryAjaxData),
				errors,
			}));
		}
		if (name === 'pincode') {
			const updatedFormValue = {...formValues};
			updatedFormValue.receiverAddress.pincode.value = value;
			updatedFormValue.receiverAddress.pincode.selectedItem = selectedItem;
			updatedFormValue.receiverAddress.pincode.errorMessage = null;
			setFormValues(updatedFormValue);
		}
		setFormValues(updatedFormValues);
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	let bookingConfirmationData = {};
	if (state.shipmentAlert) {
		bookingConfirmationData = {
			origin: formValues.sourceCounter && formValues.sourceCounter.displayName,
			destination:
				formValues.destinationCounter.selectedItem && formValues.destinationCounter.selectedItem.placeName,
			product: bookingTypeMode === '0' ? 'Envelope' : 'Parcel',
			paymentType: formValues.paymentType.selectedItem && formValues.paymentType.selectedItem.name,
			totalWeight: `${formValues.consigmentWeight} ${bookingTypeMode === '0' ? 'GMS' : 'KGS'}`,
			shipmentValue: formValues.shipmentValue.value,
			totalDistance: `${transhipmentState.distanceResponse.totalDistance} KM`,
			totalAmount: fareRes.totalAmount,
			paymentTypeId: formValues.paymentType.selectedItem && formValues.paymentType.selectedItem.id,
			paymentMode: formValues.paymentMode.selectedItem && formValues.paymentMode.selectedItem.name,
			bookingType: bookingTypeMode,
			email: formValues.toEmail.value,
			pickupType: 'HOME PICKUP',
			//eslint-disable-next-line
			deliveryType: formValues.dropTypeId.value == '142' ? 'DOOR DELIVERY' : 'COUNTER DELIVERY',
		};
	}

	const fetchDoorDeliveryPincodes = () => {
		const requestObject = {
			placeId: formValues.destinationCounter.value,
			ddPlaceName: formValues.destinationCounter.selectedItem.placeCode,
		};
		ServiceInterceptor(
			'/api/customer',
			'/places/areaPlaces',
			'POST',
			requestObject,
			(res) => {
				if (res.pincodeList && res.pincodeList.length > 0) {
					//eslint-disable-next-line
					res.pincodeList.map((item) => {
						item.areaPlaceList && item.areaPlaceList.map((area) => (area.pincode = item.pincode));
					});
					setState((prev) => ({...prev}));
				} else {
					showSnackBar('error', 'No pincodes found for home delivery!');
					// this.setState({ deliveryPincodesList: null, maxWeightLimit: null, dropTypeId: this.state.dropTypeJson[0].id, dropTypeSelectedItem: this.state.dropTypeJson[0] });
					setState((prev) => ({...prev}));
				}
			},
			(err) => {}
		);
	};
	const fetchSlotById = (placeId, date) => {
		const requestObject = {
			placeId: placeId,
			scheduledDate: date,
		};
		ServiceInterceptor(
			'/api/customer',
			'/getSlotById',
			'POST',
			requestObject,
			(res) => {
				if (res.status === '0' && res?.slotScheduleDetails?.slotBookingDto?.length > 0) {
					setState((prev) => ({...prev, slotList: res.slotScheduleDetails.slotBookingDto}));
				} else {
					showSnackBar('error', 'No slot is available now, please select another date!');
				}
			},
			(err) => {
				console.error(err);
			}
		);
	};

	const handleButtonClick = (buttonIndex, avaiId) => {
		setSelectedButton(buttonIndex);
		setState((prev) => ({...prev, availId: avaiId}));
	};
	const handleClearAddress = (type = 'sender') => {
		updateFareRes(null);
		const updatedFormValue = {...formValues, fareReq: null};
		if (type === 'sender') {
			updatedFormValue.senderAddress.houseNo.value = '';
			updatedFormValue.senderAddress.area.value = '';
			updatedFormValue.senderAddress.landmark.value = '';
			updatedFormValue.senderAddress.city.value = '';
			updatedFormValue.senderAddress.state.value = '';
			updatedFormValue.senderAddress.pincode.value = '';
			updatedFormValue.senderAddress.houseNo.errorMessage = null;
			updatedFormValue.senderAddress.area.errorMessage = null;
			updatedFormValue.senderAddress.landmark.errorMessage = null;
			updatedFormValue.senderAddress.city.errorMessage = null;
			updatedFormValue.senderAddress.state.errorMessage = null;
			updatedFormValue.senderAddress.pincode.errorMessage = null;
		} else {
			updatedFormValue.receiverAddress.houseNo.value = '';
			updatedFormValue.receiverAddress.area.value = '';
			updatedFormValue.receiverAddress.landmark.value = '';
			updatedFormValue.receiverAddress.city.value = '';
			updatedFormValue.receiverAddress.state.value = '';
			updatedFormValue.receiverAddress.pincode.errorMessage = null;
			updatedFormValue.receiverAddress.houseNo.errorMessage = null;
			updatedFormValue.receiverAddress.area.errorMessage = null;
			updatedFormValue.receiverAddress.landmark.errorMessage = null;
			updatedFormValue.receiverAddress.city.errorMessage = null;
			updatedFormValue.receiverAddress.state.errorMessage = null;
			updatedFormValue.receiverAddress.pincode.errorMessage = null;
			setClearReceiverAddress(false);
		}
		setFormValues(updatedFormValue);
	};
	const handleChange = (e, validationObj) => {
		// setFormValues((prev) => ({ ...prev, showBooking: false ,fareReq:null}))
		let {name, value} = e.target;
		const currentValue = formValues[name].value;
		updateFareRes(null);
		if ((name === 'fromMobile' || name === 'toMobile') && value.length === 10) {
			const updatedFormValues = {...formValues};
			const mobileno = name === 'fromMobile' ? value : formValues.fromMobile.value;
			const toMobileno = name === 'toMobile' ? value : formValues.toMobile.value;
			if (mobileno === toMobileno) {
				updatedFormValues[name].errorMessage = 'Sender & Receiver Mobile No. Cannot be Same!';
				setFormValues(updatedFormValues);
				return;
			} else {
				// fetchUserDetailsByMobileNo(value, name === "fromMobile" ? "sender" : "receiver");
				//todo = Need to fetch when user logged in!
			}
		} else if (name === 'vehicleType') {
			let totalWeight = 0;
			let bookingSpaceOptionsList = [];
			if (value !== VEHICLE_TYPE_DGT) {
				const listItem = {id: 616, name: 'Full'};
				bookingSpaceOptionsList.push(listItem);
				totalWeight = 1000;
			} else {
				bookingSpaceOptionsList = Array.from({length: 9}, (_, i) => ({
					id: i + 1,
					name: `${i + 1} Ton`,
				}));
				totalWeight = 1000;
			}
			setFormValues((formValue) => {
				const updatedFormValues = {...formValue};
				const rateVal = value === VEHICLE_TYPE_DGT ? '50' : '5';
				updatedFormValues.ratePerKm.value = rateVal;
				updatedFormValues.bookingSpace.selectedItem = bookingSpaceOptionsList[0];
				updatedFormValues.bookingSpace.value = bookingSpaceOptionsList[0].id;
				updatedFormValues.bookingSpace.errorMessage = null;
				updatedFormValues.pickupCharges.value = '0';
				updatedFormValues.deliveryCharges.value = '0';
				updatedFormValues.totalWeight.value = totalWeight;
				updatedFormValues.totalWeight.errorMessage = null;
				if (value !== VEHICLE_TYPE_DGT) {
					updatedFormValues.pickupCharges.value = '';
					updatedFormValues.pickupCharges.errorMessage = null;
					updatedFormValues.deliveryCharges.value = '';
					updatedFormValues.deliveryCharges.errorMessage = null;
				}
				return updatedFormValues;
			});
		} else if (name === 'bookingSpace') {
			let totalWeight = 0;
			if (formValues.vehicleType.value === VEHICLE_TYPE_DGT) {
				totalWeight = value + '000';
			} else {
				totalWeight = 10000;
			}
			setFormValues((formValue) => {
				const updatedFormValues = {...formValue};
				updatedFormValues.totalWeight.value = totalWeight;
				return updatedFormValues;
			});
		} else if (name === 'shipmentValue') {
			setFormValues((formValue) => {
				const updatedFormValues = {...formValue};
				updatedFormValues.identityNumber.errorMessage = null;
				updatedFormValues.identityTypeId.errorMessage = null;
				return updatedFormValues;
			});
		} else if (name === 'totalWeight') {
			if (formValues.vehicleType.value === VEHICLE_TYPE_DGT && value > MAX_WEIGHT_FOR_DGT) {
				value = currentValue;
			} else if (formValues.vehicleType.value === VEHICLE_TYPE_DICKEY && value > MAX_WEIGHT_FOR_DICKEY) {
				value = currentValue;
			} else if (formValues.vehicleType.value === VEHICLE_TYPE_ROOFTOP && value > MAX_WEIGHT_FOR_ROOFTOP) {
				value = currentValue;
			}
		}

		value = validateInput(value, validationObj) ? value : currentValue;
		// eslint-disable-next-line
		if (value.length > 0 && value[0] == 0) {
			return;
		}
		setFormValues({
			...formValues,
			[name]: {
				...formValues[name],
				value,
				errorMessage: null,
			},
			fareReq: null,
		});
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	const validateInput = (value, validationObj) => {
		console.log(validationObj);
		if (!validationObj) return true;
		let isValid = true;
		if (validationObj.inputType && validationObj.inputType === 'string') {
			isValid = isValid && /^[a-zA-z ]*$/.test(value);
		} else if (value && validationObj.inputType && validationObj.inputType === 'number') {
			isValid = isValid && /^[0-9.]*$/.test(value) && !value.includes('-');
		}

		if (validationObj.maxLength && value.length > validationObj.maxLength) {
			isValid = false;
		}
		if (validationObj.maxValue && value > validationObj.maxValue) {
			isValid = false;
		}
		return isValid;
	};
	const onAreaChange = (e, input, name) => {
		if (!input && !e) return;
		const updatedFormValues = {...formValues};
		if (name === 'destination') {
			updatedFormValues.receiverAddress.area.value = input;
			updatedFormValues.destinationCounter.displayName = '';
			updatedFormValues.destinationCounter.value = '';
			updatedFormValues.destinationCounter.errorMessage = null;
			updatedFormValues.destinationCounter.selectedItem = {};
			updatedFormValues.destinationState.value = '';
			updatedFormValues.destinationState.errorMessage = null;
			updatedFormValues.destinationState.selectedItem = {};
			updatedFormValues.receiverAddress.pincode.value = '';
		}
		if (name === 'source') {
			updatedFormValues.senderAddress.area.value = input;
			updatedFormValues.sourceCounter.displayName = '';
			updatedFormValues.sourceCounter.value = '';
			updatedFormValues.sourceCounter.errorMessage = null;
			updatedFormValues.sourceCounter.selectedItem = {};
			updatedFormValues.sourceState.value = '';
			updatedFormValues.sourceState.errorMessage = null;
			updatedFormValues.sourceState.selectedItem = {};
			updatedFormValues.senderAddress.pincode.value = '';
		}
		setFormValues(updatedFormValues);
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	const handleAddressChange = (event, type, validationObj) => {
		updateFareRes(null);
		setFormValues((prev) => ({...prev, fareReq: null}));
		let {name, value, selectedItem} = event.target;
		const {senderAddress, receiverAddress} = formValues;
		const currentValue =
			type === 'sender' ? formValues.senderAddress[name].value : formValues.receiverAddress[name].value;

		value = validateInput(value, validationObj) ? value : currentValue;
		if (type === 'sender') {
			senderAddress[name].value = value.trimStart();
			senderAddress[name].errorMessage = null;
			if (selectedItem) senderAddress[name].selectedItem = selectedItem;
		} else {
			receiverAddress[name].value = value.trimStart();
			receiverAddress[name].errorMessage = null;
			if (selectedItem) receiverAddress[name].selectedItem = selectedItem;
		}
		setFormValues((state) => ({...state, senderAddress, receiverAddress}));
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	const handleIdentityChange = (event) => {
		updateFareRes(null);
		setFormValues((prev) => ({...prev, showBooking: false, fareReq: null}));
		const {name, value, selectedItem} = event.target;
		const obj = formValues[name];
		if (obj) {
			obj.value = value;
			obj.errorMessage = null;
			if (selectedItem) obj.selectedItem = selectedItem;
			setFormValues((state) => ({...state, [name]: obj}));
		}
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};

	const handleInvalidId = (errorMessage) => {
		setFormValues((state) => {
			const updatedState = {...state};
			updatedState.identityNumber.errorMessage = errorMessage;
			return updatedState;
		});
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	// const handleTransshipmentChange = (index, option) => {
	//     let { transshipment, transshipmentCount, distanceResponse, referenceRouteIdList } = transhipmentState;
	//     if (!option) {
	//         transshipment.splice(index);
	//         transshipmentCount = index;
	//     } else {

	//         if (!transshipment[index]) {
	//             transshipment[index] = {};
	//         }
	//         transshipment[index].value = option && option.id;
	//         transshipment[index].selectedItem = option;

	//     }

	//     if (distanceResponse && distanceResponse.referenceRouteIdList && distanceResponse.referenceRouteIdList.length > 0) {
	//         referenceRouteIdList = [{ ...distanceResponse.referenceRouteIdList[0] }];
	//     } else {
	//         referenceRouteIdList = [{}];
	//     }
	//     referenceRouteIdList[0].startPlaceID = formValues.sourceCounter.value;
	//     referenceRouteIdList[0].endPlaceID = formValues.destinationCounter.value;

	//     new Array(transshipmentCount).fill(null).forEach((_, index) => {
	//         const transShipmentPoint = transshipment[index];
	//         if (transShipmentPoint && transShipmentPoint.value) {
	//             referenceRouteIdList[referenceRouteIdList.length - 1].endPlaceID = transShipmentPoint.value;
	//             referenceRouteIdList.push(
	//                 {
	//                     startPlaceID: transShipmentPoint.value,
	//                     endPlaceID: formValues.destinationCounter.value,
	//                 }
	//             );
	//         }
	//     });
	//     updateFareRes(null)
	//     setFormValues((prev) => ({ ...prev, showBooking: false }))
	//     setTranshipmentState((prev) => ({ ...prev, transshipment, transshipmentCount, referenceRouteIdList }));
	//     getPlacesDistance(formValues.sourceCounter.value, formValues.destinationCounter.value, 'pickupDistance', formValues.sourceLocation.distance);
	// }

	const hideSnackBar = () => {
		updateSnackBar(null);
	};
	// const resetTransshipmentPoints = () => {
	//     setTranshipmentState({ transshipmentCount: 0, transshipment: [], transshipmentList: null, fetchingTransshipment: false })
	//     setFormValues((prev) => ({ ...prev, showBooking: false }))
	//     updateFareRes(null)
	// }
	const handleChangeParam = (event, heading, addParam, validationObj) => {
		setFormValues((prev) => ({...prev, showBooking: false, fareReq: null}));
		let name = event.target.name;
		let errors = state.errors;
		let value = event.target.value;
		const currentValue = state[name];
		value = validateInput(value, validationObj) ? value : currentValue;
		// eslint-disable-next-line
		if (value?.length > 0 && value[0] == 0) {
			return;
		}
		updateFareRes(null);
		setState((prev) => ({...prev, bookingRes: null}));
		if (name === 'actualweight') {
			value = validateInput(value, {
				inputType: 'number',
				maxValue:
					bookingTypeMode === '0'
						? MAX_ENVELOPE_ACTUAL_WEIGHT
						: (bookingConfig && bookingConfig.maxWeight) || MAX_ACTUAL_WEIGHT,
			})
				? value
				: currentValue;
			setState((prev) => ({...prev, originalWeight: value}));
		}
		if (name === 'unit') {
			value = parseInt(value);
		}
		if (name === 'actualweight' || name === 'unit') {
			const actwt = parseFloat((name === 'actualweight' ? value : state.actualweight) || '0');
			let qty = parseFloat((name === 'unit' ? value : state.unit) || '1');
			qty = qty > 0 ? qty : 1;
			setState((prev) => ({...prev, totalweight: (actwt * qty).toFixed(2)}));
			setState((prev) => ({...prev, isWeighingMachine: false}));
		}

		errors[name] = null;
		if (addParam && addParam.isRequired && !value) {
			errors[name] = `${heading} is required!`;
		}
		setState((prev) => ({...prev, errors, [name]: value}));
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	const handleSwitchChange = (switchObj, value) => {
		let name = switchObj.column;
		setState((prev) => ({...prev, [name]: value}));
	};
	const handleDropDownChange = (event) => {
		// let name = event.target.name;
		setBookingTypeMode(event.target.value);
		dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: event.target.value}});
	};
	const handleAddFieldDropdownChange = (event, ajaxData) => {
		const data = JSON.parse(ajaxData);
		const {name, value} = event.target;
		const selectedObj = data.find((item) => item.id === value);
		const updatedFormValues = {...formValues};
		if (!updatedFormValues[name] || typeof updatedFormValues[name] !== 'object') updatedFormValues[name] = {};
		updatedFormValues[name].value = value;
		updatedFormValues[name].errorMessage = null;
		updatedFormValues[name].selectedItem = selectedObj;
		setFormValues(updatedFormValues);
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	const handleInputBlur = ({target}) => {
		let {name, value} = target;
		if (name === 'actualweight') {
			let roundOffWeight = roundOffBookingWeight(value);
			if (
				roundOffWeight >
				(bookingTypeMode === '0'
					? MAX_ENVELOPE_ACTUAL_WEIGHT
					: (bookingConfig && bookingConfig.maxWeight) || MAX_ACTUAL_WEIGHT)
			) {
				roundOffWeight = parseFloat(
					bookingTypeMode === '0'
						? MAX_ENVELOPE_ACTUAL_WEIGHT
						: (bookingConfig && bookingConfig.maxWeight) || MAX_ACTUAL_WEIGHT
				).toFixed(2);
			}
			let qty = parseFloat(state.unit || '1');
			qty = qty > 0 ? qty : 1;
			value = (roundOffWeight * qty).toFixed(2);
			setState((prev) => ({
				...prev,
				actualweight: roundOffWeight,
				totalweight: value,
			}));
		}
	};
	// const handleReadWeightFromMachine = () => {
	// 	weighingHelper.getWeightFromWeighingMachine(({weight}) => {
	// 		if (weight > 0) setState((prev) => ({...prev, isWeighingMachine: true}));

	// 		handleChangeParam(
	// 			{
	// 				target: {
	// 					name: 'actualweight',
	// 					value: weight,
	// 				},
	// 			},
	// 			'Actual Weight'
	// 		);
	// 	});
	// };
	// const valid = (current) => {
	//   var yesterday = Date.moment().subtract(1, "day");
	//   return current.isAfter(yesterday);
	// };
	const getSubCategoryListByProductCode = (productCode, subCategoryList) => {
		if (!productCode || !subCategoryList) return '[]';
		//eslint-disable-next-line
		return JSON.stringify(subCategoryList.filter((item) => item.parentCode == productCode) || []);
	};
	const handleWeightItemEdit = (index) => {
		setIsCourier(false);
		if (bookingTypeMode === '0') setFormValues((prev) => ({...prev, fareReq: null}));
		let {weightInfo, actualweight, unit, totalweight, length, breadth, height} = state;
		let {carrierTypeId, cargoTypeId, subProductTypeId, pieceTypeId} = formValues;
		// if (editWeightInfoIndex === index) return;
		const item = weightInfo[index];
		if (item) {
			carrierTypeId = item.carrierTypeId || '';
			cargoTypeId = item.cargoTypeId || '';
			subProductTypeId = item.subProductTypeId || '';
			pieceTypeId = item.pieceTypeId || '';
			actualweight = item.actualWeight || '';
			unit = item.noOfpiece || '';
			totalweight = item.totalWeight || '';
			length = item.length || '';
			breadth = item.breadth || '';
			height = item.height || '';
			//eslint-disable-next-line
			const prd = (state.cargoTypeList && state.cargoTypeList.find((i) => i.id == item.cargoTypeId)) || {};
			const subCategoryOptions = getSubCategoryListByProductCode(prd.code, state.subCategoryAjaxData);
			setState((prev) => ({
				...prev,
				carrierTypeId,
				cargoTypeId,
				subProductTypeId,
				pieceTypeId,
				actualweight,
				unit,
				totalweight,
				length,
				breadth,
				height,
				editWeightInfoIndex: index,
				subCategoryOptions,
			}));
		}
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};

	const handleWeightItemDelete = (index) => {
		setIsCourier(false);
		const {weightInfo} = state;
		// if (editWeightInfoIndex > -1) return;
		weightInfo.splice(index, 1);
		console.log(weightInfo, index, 'weight');
		setFormValues((prev) => ({...prev, showBooking: false, fareReq: null}));
		setState((prev) => ({...prev, weightInfo}));
		updateFareRes(null);
		// dispatch({type: CUSTOMER_DATA, data: {...formValues, ...state, bookingTypeMode: bookingTypeMode}});
	};
	const addField = (addParam) => {
		switch (addParam.type) {
			case 'labelLine':
				return (
					<Grid item xs={12} id={addParam.column}>
						<Typography variant="subtitle2" component="h2" style={{color: '#9fa7a7'}}>
							{addParam.heading}
						</Typography>
					</Grid>
				);

			case 'label':
				return <Grid item lg={3} id={addParam.column}></Grid>;

			case 'text_field':
				const inputLabelProps = {};
				if (addParam.hasOwnProperty('shrinkInput') && addParam.shrinkInput) {
					inputLabelProps.shrink = true;
				}
				return (
					<Grid item xs={12} md={6} lg={3} style={{display: addParam.display}} id={addParam.column}>
						<TextField
							//ref={addParam.column}
							required={addParam.isRequired ? true : false}
							name={addParam.column}
							value={state[addParam.column] || ''}
							variant="outlined"
							size="small"
							id={addParam.column}
							disabled={addParam.disabled ? true : false}
							style={{width: '100%'}}
							label={addParam.heading}
							onChange={(event) =>
								handleChangeParam(event, addParam.heading, addParam, addParam.validationObj)
							}
							error={state.errors && state.errors[addParam.column] ? true : false}
							helperText={state.errors ? state.errors[addParam.column] : ''}
							inputProps={{maxLength: addParam.maxlength}}
							InputLabelProps={inputLabelProps}
							onBlur={handleInputBlur}
							autoComplete="off"
							type={addParam.inputType || 'text'}
							InputProps={
								addParam.column === 'actualweight' || addParam.column === 'totalweight'
									? {
											endAdornment: (
												<InputAdornment position="end">
													{bookingTypeMode === '0' ? "GM's" : "KG's"}
												</InputAdornment>
											),
									  }
									: null
							}
						/>
					</Grid>
				);
			case 'radio':
				return (
					<Grid item xs={12} md={6} lg={3}>
						<FormControlLabel
							value="top"
							control={<Radio color="primary" />}
							label={addParam.heading}
							labelPlacement="left"
							name={addParam.column}
						/>
					</Grid>
				);
			case 'date':
				// if (state[addParam.column] != undefined) {
				//   var date = moment(state[addParam.column]);
				//   return (
				//     <Grid
				//       item
				//       xs={12}
				//       md={6}
				//       lg={3}
				//       style={{ display: addParam.display }}
				//     >
				//       <div style={{ marginTop: 8, display: addParam.display }}>
				//         <Date
				//           required
				//           timeFormat={false}
				//           dateFormat="YYYY-MM-DD"
				//           onChange={(event) => handleDate(event, addParam.column)}
				//           name={addParam.column}
				//           defaultValue={date}
				//           inputProps={{
				//             endAdornment: (
				//               <InputAdornment position="end">
				//                 <TodayIcon color="primary" />
				//               </InputAdornment>
				//             ),
				//             placeholder: addParam.heading,
				//           }}
				//           isValidDate={valid}
				//           closeOnSelect={true}
				//         />
				//       </div>
				//     </Grid>
				//   );
				// }

				break;
			case 'text_area':
				return (
					<Grid item xs={12} md={6} lg={3} style={{display: addParam.display}}>
						<TextareaAutosize
							rowsMax={4}
							rows={3}
							style={{
								borderRadius: 4,
								borderColor: '#c4c4c4',
								height: '100%',
							}}
							aria-label={addParam.column}
							placeholder={addParam.heading}
							name={addParam.column}
							defaultValue={state[addParam.column]}
							onChange={(event) => handleChangeParam(event, null)}
							autoComplete="off"
						/>
					</Grid>
				);
			case 'switch':
				return (
					<Grid item xs={12} md={6} lg={3}>
						<FormControl variant="outlined">
							<FormGroup aria-label="position" row>
								<FormControlLabel
									value={state[addParam.column]}
									control={
										<Tooltip title={addParam.heading} placement="top">
											<Switch
												color="primary"
												checked={state[addParam.column]}
												name={addParam.column}
												onChange={(event) =>
													handleSwitchChange(addParam, !state[addParam.column])
												}
											/>
										</Tooltip>
									}
									label={addParam.heading}
									style={{marginLeft: '2px', marginTop: '10px'}}
									labelPlacement="start"
								/>
							</FormGroup>
						</FormControl>
					</Grid>
				);
			case 'dropdown':
				return (
					<Grid item xs={12} md={6} lg={3}>
						<FormControl size="small" variant="outlined" fullWidth>
							<InputLabel id={addParam.heading}>
								{addParam.heading}
								{addParam.isRequired ? ' *' : null}
							</InputLabel>
							<Select
								margin="dense"
								labelId={addParam.heading}
								id={addParam.heading + 'select'}
								name={addParam.column}
								value={state[addParam.column]}
								error={
									formValues &&
									formValues[addParam.column] &&
									formValues[addParam.column].errorMessage
										? true
										: false
								}
								onChange={(e) => handleAddFieldDropdownChange(e, addParam.ajaxData)}
								labelWidth={
									addParam.isRequired ? 8.2 * addParam.heading.length : 7.2 * addParam.heading.length
								}
								inputProps={{
									name: addParam.column,
									id: addParam.column,
								}}>
								{JSON.parse(addParam.ajaxData).map((data) => {
									if (data) {
										return <MenuItem value={data.id}>{data.name}</MenuItem>;
									}
									return data;
								})}
							</Select>
							{formValues && formValues[addParam.column] && formValues[addParam.column].errorMessage && (
								<FormHelperText error={true}>
									{formValues[addParam.column] ? formValues[addParam.column].errorMessage : ''}
								</FormHelperText>
							)}
						</FormControl>
					</Grid>
				);
			case 'empty_field':
				return (
					<Grid item xs={12}>
						<div />
					</Grid>
				);
			case 'divider':
				return (
					<Grid item xs={12} style={{display: addParam.display}} id={addParam.column}>
						<Typography variant="button" style={{color: '#6b6565'}}>
							{addParam.heading}
						</Typography>
						<Divider
							variant="inset"
							component="p"
							style={{width: '100%', marginLeft: '0px', marginBottom: '10px'}}
						/>
					</Grid>
				);

			case 'divider_button':
				return (
					<Grid item xs={12}>
						<Typography variant="button" style={{color: '#6b6565'}}>
							{addParam.heading}
						</Typography>
						<Divider
							variant="inset"
							component="p"
							style={{width: '100%', marginLeft: '0px', marginBottom: '10px'}}
						/>
					</Grid>
				);

			case 'ajax':
				if (addParam.ajaxData) {
					let parsedData =
						state.ajaxData && state.ajaxData[addParam.column]
							? state.ajaxData[addParam.column]
							: JSON.parse(addParam.ajaxData);
					if (addParam.column === 'subProductTypeId') {
						if (state.subCategoryOptions.length > 100) {
							parsedData = JSON.parse(state.subCategoryOptions);
						}
					}
					let selectedItem = {};
					const optionData = parsedData.map((option) => {
						if (
							option.id ===
							(formValues[addParam.column] &&
								formValues[addParam.column].selectedItem &&
								formValues[addParam.column].selectedItem.id)
						) {
							selectedItem = option;
						}
						const firstLetter = option.name[0].toUpperCase();
						return {
							firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
							...option,
						};
					});

					var index = null;
					if (addParam.defaultValue !== '0') {
						var tempData =
							state.ajaxData && state.ajaxData[addParam.column]
								? state.ajaxData[addParam.column]
								: JSON.parse(addParam.ajaxData);
						var filteredData = tempData.filter((module, i, rep) => {
							if (module.id === addParam.defaultValue) {
								index = rep.indexOf(module);
								return module.name;
							} else {
								return {
									filteredData: /[0-9]/.test(filteredData) ? '0-9' : filteredData,
									...module,
								};
							}
						});
					}
					const sortedData = optionData.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter));
					return (
						<Grid item xs={12} md={6} lg={3} style={{display: addParam.display}} id={addParam.column}>
							<Autocomplete
								id={addParam.column}
								options={sortedData || []}
								getOptionLabel={(option) => {
									return (option && option.name) || '';
								}}
								defaultValue={
									addParam.defaultValue && addParam.defaultValue === '1'
										? optionData[0]
										: optionData[index]
								}
								value={selectedItem || null}
								onChange={(_, option) =>
									handleAutoCompleteSelect(addParam.column, option && option.name, option)
								}
								name={addParam.heading}
								clearOnEscape={true}
								renderInput={(params) => (
									<TextField
										required={addParam.isRequired ? true : false}
										variant="outlined"
										error={
											formValues[addParam.column] && formValues[addParam.column].errorMessage
												? true
												: false
										}
										helperText={
											formValues[addParam.column] ? formValues[addParam.column].errorMessage : ''
										}
										{...params}
										label={addParam.heading}
										fullWidth
										size="small"
										autoComplete="off"
									/>
								)}
							/>
						</Grid>
					);
				} else {
					return (
						<Grid item xs={12} md={6} lg={3}>
							<InputLabel name={addParam.column} ref={addParam.heading} id={addParam.heading}>
								{addParam.heading}
								{addParam.isRequired ? ' *' : null}
							</InputLabel>
						</Grid>
					);
				}
			default:
			// code block
		}
	};
	const getVolumetricWeight = (length, breadth, height, carrierTypeId) => {
		length = parseInt(length);
		breadth = parseInt(breadth);
		height = parseInt(height);

		let divisor = 0;
		if (carrierTypeId.selectedItem.id === CARRIER_TYPE_INSIDE_DICKEY) divisor = 2500;
		else if (carrierTypeId.selectedItem.id === CARRIER_TYPE_ROOF_TOP) divisor = 4000;

		return ((length * breadth * height) / divisor).toFixed(2);
	};
	const handleAddItem = (event) => {
		if (bookingTypeMode === '0') {
			setIsCourier(true);
		}
		const {carrierTypeId, cargoTypeId, subProductTypeId, pieceTypeId} = formValues;
		const {actualweight, totalweight, unit, weightInfo, length, breadth, height, editWeightInfoIndex} = state;
		if (bookingTypeMode === '1') {
			let currentTotalWeight = 0;
			if (state.weightInfo.length) {
				state.weightInfo.forEach((item, index) => {
					if (state.editWeightInfoIndex !== undefined && state.editWeightInfoIndex === index) return;
					else {
						currentTotalWeight += Number(item.totalWeight);
					}
				});
			}
			currentTotalWeight += Number(totalweight);
			if (currentTotalWeight > (bookingConfig.maxWeight || MAX_ACTUAL_WEIGHT)) {
				setState((prev) => ({
					...prev,
					weightInfo,
					actualweight: '',
					totalweight: '',
					unit: '',
					length: '',
					breadth: '',
					height: '',
					editWeightInfoIndex: -1,
				}));
				alert(`Total weight should not be more than ${bookingConfig.maxWeight || MAX_ACTUAL_WEIGHT}`);
				return;
			}
		}

		setFormValues((prev) => ({...prev, showBooking: false}));
		updateFareRes(null);
		let errors = state.errors;
		var isErrorExist = false;

		const updatedFormValues = {...formValues};
		let weightFields = ['carrierTypeId', 'cargoTypeId', 'subProductTypeId', 'pieceTypeId'];
		if (bookingTypeMode === '0') {
			//eslint-disable-next-line
			const excludedSubProductTypeId = weightFields.splice(2, 1);
		}
		weightFields.forEach((item) => {
			if (!formValues.hasOwnProperty(item) || !formValues[item].value) {
				if (!updatedFormValues.hasOwnProperty(item)) updatedFormValues[item] = {};
				updatedFormValues[item].errorMessage = 'Field is required!';
				isErrorExist = true;
			}
		});
		setFormValues(updatedFormValues);
		if (!actualweight) {
			errors['actualweight'] = 'Field is required!';
			setState((prev) => ({...prev, errors}));
			isErrorExist = true;
		} else if (parseInt(actualweight) < 1) {
			errors['actualweight'] = 'Should be greater than 0';
			setState((prev) => ({...prev, errors}));
			isErrorExist = true;
		} else if (cargoTypeId === PRODUCT_TYPE_VEGETABLE && parseFloat(actualweight) > 80) {
			errors['actualweight'] = 'Should not be greater than 80';
			setState((prev) => ({...prev, errors}));
			isErrorExist = true;
		}
		if (!unit) {
			errors['unit'] = 'Field is required!';
			setState((prev) => ({...prev, errors}));
			isErrorExist = true;
		} else if (parseInt(unit) < 1) {
			errors['unit'] = 'Should be greater than 0';
			setState((prev) => ({...prev, errors}));
			isErrorExist = true;
		}
		// if(!totalweight) {
		//     errors["totalweight"] = 'Field is required!';
		//     this.setState({ errors, ["totalweight"]: event.target.value });
		//     isErrorExist =true;
		// }
		if (volumetricCarrierTypeIds.includes(carrierTypeId && carrierTypeId.selectedItem.id)) {
			if (!length || length < 1) {
				errors['length'] = 'Length is required!';
				setState((prev) => ({...prev, errors}));
				isErrorExist = true;
			}
			if (!breadth || breadth < 1) {
				errors['breadth'] = 'Breadth is required!';
				setState((prev) => ({...prev, errors}));
				isErrorExist = true;
			}
			if (!height || height < 1) {
				errors['height'] = 'Height is required!';
				setState((prev) => ({...prev, errors}));
				isErrorExist = true;
			}
		}

		if (isErrorExist) {
			return true;
		}

		const weightInfoData = {
			carrierTypeId: {...carrierTypeId, selectedItem: {...carrierTypeId.selectedItem}},
			cargoTypeId: {...cargoTypeId, selectedItem: {...cargoTypeId.selectedItem}},
			subProductTypeId: {...subProductTypeId, selectedItem: {...subProductTypeId.selectedItem}},
			pieceTypeId: {...pieceTypeId, selectedItem: {...pieceTypeId.selectedItem}},
			actualWeight: actualweight,
			totalWeight: totalweight,
			noOfpiece: unit,
			productTypeId: {...cargoTypeId, selectedItem: {...cargoTypeId.selectedItem}},
			carrierTypeName: carrierTypeId.selectedItem.name,
			productTypeName: cargoTypeId.selectedItem.name,
			subProductTypeName: bookingTypeMode === '1' ? subProductTypeId.selectedItem.name : '',
			pieceTypeName: pieceTypeId.selectedItem.name,
		};
		if (volumetricCarrierTypeIds.includes(carrierTypeId && carrierTypeId.selectedItem.id)) {
			const volumetricActualWeight = getVolumetricWeight(length, breadth, height, carrierTypeId);
			console.log('volumetricActualWeight', volumetricActualWeight);
			weightInfoData.length = length;
			weightInfoData.breadth = breadth;
			weightInfoData.height = height;
			weightInfoData.actualWeight = actualweight;
			weightInfoData.calculatedActualWeight =
				parseFloat(actualweight) > volumetricActualWeight ? actualweight : volumetricActualWeight;
			// weightInfoData.calculatedActualWeight = parseFloat(actualweight);
			weightInfoData.totalWeight = weightInfoData.calculatedActualWeight * parseInt(unit);
		}

		const actionIndex = editWeightInfoIndex !== -1 ? editWeightInfoIndex : weightInfo.length || 0;
		weightInfoData.action = (
			<Grid container style={{flexWrap: 'nowrap'}}>
				<Tooltip title="Edit" placement="bottom">
					<EditIcon
						color="primary"
						onClick={() => handleWeightItemEdit(actionIndex)}
						style={{cursor: 'pointer'}}
					/>
				</Tooltip>
				<Tooltip title="Delete" placement="bottom">
					<DeleteIcon
						color="secondary"
						onClick={() => handleWeightItemDelete(actionIndex)}
						style={{cursor: 'pointer'}}
					/>
				</Tooltip>
			</Grid>
		);
		if (bookingTypeMode === '1' && Number(weightInfoData.totalWeight) > 50) {
			alert(
				`For more than ${bookingConfig.maxWeight} Kgs Bookings, please contact customer care no. 0866 2570006`
			);
			return;
		}
		if (bookingTypeMode === '0' && Number(weightInfoData.totalWeight) > 1000) {
			alert(`Not more than 1 kg`);
			setIsCourier(false);
			return;
		}
		if (editWeightInfoIndex !== -1) weightInfo.splice(editWeightInfoIndex, 1, weightInfoData);
		else weightInfo.push(weightInfoData);
		setState((prev) => ({
			...prev,
			weightInfo,
			actualweight: '',
			totalweight: '',
			unit: bookingTypeMode === '0' ? 1 : '',
			length: '',
			breadth: '',
			height: '',
			editWeightInfoIndex: -1,
		}));
	};
	const validateForm = (ignoreKeysArr = []) => {
		const ignoreKeys = [
			'fromGstin',
			'slotList',
			'availId',
			'senderAddress',
			'receiverAddress',
			'identityTypeId',
			'identityNumber',
			'toEmail',
			'toGstin',
			'standard',
			'general',
			'unloadingCharges',
			'pickupCharges',
			'deliveryCharges',
			'totalWeight',
			'statesList',
			'totalweight',
			'subCategoryAjaxData',
			'subCategoryList',
			'subCategoryOptions',
			'cargoTypeList',
			'carrierTypeList',
			'editWeightInfoIndex',
			'actualweight',
			'unit',
			'enableDoorDelivery',
			'errors',
			'isMobile',
			'isWeighingMachine',
			'pieceTypeList',
			'pieceTypeListAjax',
			'weightInfo',
			'areaPincodeDetails',
			'sourceAreaPincodeDetails',
			'areaPincodeList',
			'sourcePincodeList',
			0,
			'consigmentWeight',
			'fareReq',
			'shipmentAlert',
			'bookingID',
			'stackbarType',
			'originalWeight',
			'pincodesList',
			'pincodeSourceList',
			'nearestPoint',
			'articleImage',
			'articleImageSelection',
			'bookingConfig',
			'captureImageFor',
			'tabIndex',
			'isLoading',
			'showRetryPopup',
			'saveBookingResponse',
			'loadPrint',
			'isItemAddStart',
			'showOverView',
			'stockNo',
			'bookingRes',
			...ignoreKeysArr,
		];
		let isInvalidForm = false;
		let newFormValues = {...formValues, ...state};
		Object.keys(newFormValues.receiverAddress).forEach((key) => {
			if (!newFormValues.receiverAddress[key].value && !newFormValues.receiverAddress[key].ignore) {
				newFormValues.receiverAddress[key].errorMessage = `This field is required!`;
				isInvalidForm = true;
			}
		});
		if (
			!newFormValues.receiverAddress.pincode.errorMessage &&
			(!newFormValues.receiverAddress.pincode.value || newFormValues.receiverAddress.pincode.value.length !== 6)
		) {
			newFormValues.receiverAddress.pincode.errorMessage = `Invalid Pincode`;
			isInvalidForm = true;
		}
		Object.keys(newFormValues).forEach((key) => {
			if (bookingTypeMode === '0' && key === 'subProductTypeId') return null;
			if (ignoreKeys.includes(key)) return null;
			if (isLocationEnabled && key === 'sourceDistrict') return null;
			if (isLocationEnabled && key === 'sourceLocation') return null;
			if (newFormValues[key] && !newFormValues[key].value) {
				console.log(newFormValues[key], 'newFormValues[key]', key, newFormValues);
				if (!newFormValues[key] || typeof !newFormValues[key] !== 'object') newFormValues[key] = {};
				newFormValues[key].errorMessage = 'This field is required!';
				isInvalidForm = true;
			}
		});

		const emailRegex = new RegExp(REGEX_EMAIL);
		if (newFormValues.fromEmail.value && emailRegex.test(newFormValues.fromEmail.value) === false) {
			newFormValues.fromEmail.errorMessage = 'Invalid email address!';
			isInvalidForm = true;
		}
		if (newFormValues.toEmail.value && emailRegex.test(newFormValues.toEmail.value) === false) {
			newFormValues.toEmail.errorMessage = 'Invalid email address!';
			isInvalidForm = true;
		}
		if (
			!newFormValues.fromMobile.errorMessage &&
			(INVALID_MOBILE_NO.includes(newFormValues.fromMobile.value) ||
				new RegExp(REGEX_MOBILE_NO).test(newFormValues.fromMobile.value) === false)
		) {
			newFormValues.fromMobile.errorMessage = 'Invalid Mobile No.';
			isInvalidForm = true;
		}
		if (
			!newFormValues.toMobile.errorMessage &&
			(INVALID_MOBILE_NO.includes(newFormValues.toMobile.value) ||
				new RegExp(REGEX_MOBILE_NO).test(newFormValues.toMobile.value) === false)
		) {
			newFormValues.toMobile.errorMessage = 'Invalid Mobile No.';
			isInvalidForm = true;
		}

		Object.keys(newFormValues.senderAddress).forEach((key) => {
			if (!newFormValues.senderAddress[key].value && !newFormValues.senderAddress[key].ignore) {
				newFormValues.senderAddress[key].errorMessage = `This field is required!`;
				isInvalidForm = true;
			}
		});
		if (newFormValues.weightInfo.length < 1) {
			alert('Add the weight');
			scrollIntoView('#customer-weightInfo');
			isInvalidForm = true;
		}
		if (parseInt(newFormValues.shipmentValue.value || '0') > IDENTITY_MANDATORY_FROM_SHIPMENT_VALUE) {
			if (!newFormValues.identityTypeId.value) {
				isInvalidForm = true;
				newFormValues.identityTypeId.errorMessage = 'Field is required!';
			}
			if (!newFormValues.identityNumber.value) {
				isInvalidForm = true;
				newFormValues.identityNumber.errorMessage = 'Field is required!';
			}
		}

		if (!newFormValues.identityTypeId.value) {
			isInvalidForm = true;
			newFormValues.identityTypeId.errorMessage = 'Field is required!';
		}
		if (!newFormValues.identityNumber.value) {
			isInvalidForm = true;
			newFormValues.identityNumber.errorMessage = 'Field is required!';
		}
		isInvalidForm = !validateIdentity(newFormValues.identityTypeId, newFormValues.identityNumber) || isInvalidForm;

		if (!newFormValues.shipmentValue.value || parseInt(newFormValues.shipmentValue.value) < 1) {
			isInvalidForm = true;
			newFormValues.shipmentValue.errorMessage = `Shipment value should be greater than 0`;
		}
		if (newFormValues.toEmail.value === newFormValues.fromEmail.value) {
			isInvalidForm = true;
			newFormValues.toEmail.errorMessage =
				'Receiver email address should not be the same as that of sender email address!';
		}
		setFormValues(newFormValues);
		if (isInvalidForm) {
			alert('Please fill the form correctly!');
			setTimeout(scrollToErrorElement, 100);
		} else if (!isInvalidForm && state.editWeightInfoIndex >= 0) {
			isInvalidForm = true;
			alert('Update the weight');
			scrollIntoView('#customer-weightInfo');
		}
		return isInvalidForm;
	};

	const handleUserConsentChange = () => {
		setIsUserConsented((isConsented) => !isConsented);
	};
	const handlePackagingChange = (name) => {
		const updatedFormValues = {...formValues};
		updatedFormValues.fareReq = null;
		updatedFormValues.showBooking = false;
		setFormValues(updatedFormValues);
		updateFareRes(null);
		setPackaging((prev) => ({...prev, [name]: !prev[name]}));
	};
	const showBookingFare = (event, addParam) => {
		event.preventDefault();
		var totalWeight = 0;
		let newFormValues = {...formValues, ...state};
		const transformData = (data) => {
			return data.map((item, index) => {
				console.log(item);
				return {
					carrierTypeId: item.carrierTypeId.selectedItem.id.toString(),
					cargoTypeId: item.cargoTypeId.selectedItem.id.toString(),
					subProductTypeId: bookingTypeMode === '1' ? item.subProductTypeId.selectedItem.id.toString() : '',
					pieceTypeId: item.pieceTypeId.selectedItem.id.toString(),
					actualWeight: item.actualWeight,
					totalWeight: item.totalWeight,
					noOfpiece: item.noOfpiece,
					productTypeId: item.productTypeId.selectedItem.id.toString(),
					length: item.length || '',
					breadth: item.breadth || '',
					height: item.height || '',
				};
			});
		};
		const weightInfo = transformData(newFormValues.weightInfo);

		const reqObj = {
			startPlaceId: newFormValues.sourceCounter.value,
			endPlaceId: newFormValues.destinationCounter.value,
			shipmentValue: newFormValues.shipmentValue.value,
			dropTypeId: newFormValues.dropTypeId.value,
			paymentMode: newFormValues.paymentMode.value,
			paymentType: newFormValues.paymentType.value,
			deliveryPincode: {
				value: newFormValues.receiverAddress.pincode.value || '',
			},
			deliveryArea: {value: newFormValues.receiverAddress.area?.selectedItem?.areaCode || ''},
			deliveryAreaName: {value: newFormValues.receiverAddress.area?.selectedItem?.areaName || ''},
			senderAreaCode: formValues.senderAddress.area?.selectedItem?.areaCode,
			weightInfo: weightInfo,
			length: state.length,
			breadth: state.breadth,
			height: state.height,
			availId: state.availId,
			optPacking: packaging.isCoverPackaging ? '1' : '0',
			optPlasticPacking: packaging.isPlasticPackaging ? '1' : '0',
			pickUpDate: formValues.pickUpDate.value,
		};
		// console.log(reqObj, 'reqObj')
		if (!validateForm()) {
			if (newFormValues.weightInfo.length > 0) {
				for (let i = 0; i <= newFormValues.weightInfo.length; i++) {
					if (newFormValues['weightInfo'][i]) {
						totalWeight += Number(newFormValues.weightInfo[i].totalWeight);
						//eslint-disable-next-line
						setFormValues((prev) => ({
							...prev,
							fareReq: reqObj,
							consigmentWeight: totalWeight,
						}));
					}
				}
			} else {
				totalWeight = newFormValues.totalWeight;
				setFormValues((prev) => ({
					...prev,
					fareReq: reqObj,
					consigmentWeight: totalWeight,
					weightInfo: weightInfo,
				}));
			}
			setFormValues((prev) => ({
				...prev,
				fareReq: reqObj,
				weightInfo: weightInfo,
				showBooking: true,
			}));
		} else {
			setFormValues((prev) => ({
				...prev,
				showBooking: false,
				weightInfo: weightInfo,
			}));
			updateFareRes(null);
		}
	};
	const handleFareCallback = (fareResponse) => {
		if (fareResponse) {
			updateFareRes(fareResponse);
		} else {
			setFormValues((prev) => ({...prev, showBooking: false, fareReq: null}));
			updateFareRes(null);
		}
	};
	const handlePerformCaptureImage = (captureImageFor) => {
		if (captureImageFor === CAPTURE_IMAGE_OF_ARTICLE && state.articleImageSelection) {
			articleImageUploadRef.current && articleImageUploadRef.current.click();
		} else {
			setState((prev) => ({...prev, captureImageFor}));
		}
	};

	const handleImageCapturePopupClose = () => {
		setState((prev) => ({...prev, captureImageFor: null}));
	};
	const handleImageCaptureResponse = (imageData, capturedFor) => {
		setState((prev) => ({...prev, articleImage: imageData}));
	};
	const handleImageSelect = (evt) => {
		const file = evt.target.files[0];

		if (file) {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.addEventListener('load', () => {
				setState((prev) => ({...prev, articleImage: reader.result}));
			});
		}
	};
	const handletabCount = (type) => {
		if (type === 'Increament') {
			count++;
		} else {
			count = 0;
		}
	};

	// const handlePrint = () => {
	//     if (state.isMobile) {
	//         if (window.cargo && window.cargo.printLogisticsInfo) {
	//             const bookedBy = 'sample'
	//             const printTemplate = generateMobileLrPrintTemplate(state.bookingRes, BOOKING_TYPE_PARCEL, bookedBy);
	//             window.cargo.printLogisticsInfo(JSON.stringify(printTemplate));
	//         } else {
	//             showSnackBar('error', 'Printer configuration not found!');
	//         }
	//     } else {
	//         setTimeout(window.print, 1000);
	//     }
	// }
	const handleBookAgain = () => {
		resetBookingForm();
		fetchHeaders && fetchHeaders();
		// fetchBookingPlaces();
		fetchStatesList();
		fetchDistrictList();
		fetchBookingConfiguration();
	};
	const resetBookingForm = (persistLocationInfo = false) => {
		let customerObj = JSON.parse(localStorage.getItem('customerDetails'));
		console.log('resetBookingForm ');
		const locationInfo = {
			sourceState: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},
			sourceDistrict: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},
			sourceCounter: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},
			sourceLocation: {
				value: '',
				selectedItem: null,
				errorMessage: null,
				distance: null,
			},
			//destination
			destinationState: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},
			// destinationDistrict: {
			//     value: '',
			//     selectedItem: {},
			//     errorMessage: null
			// },
			destinationCounter: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},

			fromMobile: {
				value: (customerObj && customerObj.customerAddress && customerObj.customerAddress.mobileNumber) || '',
			},
			fromName: {
				value: (customerObj && customerObj.customerAddress && customerObj.customerAddress.customerName) || '',
			},
			fromEmail: {
				value: (customerObj && customerObj.customerAddress && customerObj.customerAddress.email) || '',
			},
			fromGstin: {value: ''},
			area: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},
			senderAddress: {
				houseNo: {
					value: (customerObj && customerObj.customerAddress && customerObj.customerAddress.address1) || '',
					errorMessage: null,
				},
				area: {
					value: '',
					errorMessage: null,
					ignore: true,
				},
				landmark: {
					value: '',
					errorMessage: null,
				},
				city: {
					value: '',
					errorMessage: null,
				},
				pincode: {
					value: '',
					errorMessage: null,
					ignore: true,
				},
			},
			identityTypeId: {value: '', selectedItem: null},
			identityNumber: {value: ''},

			toMobile: {value: ''},
			toName: {value: ''},
			toEmail: {value: ''},
			toGstin: {value: ''},
			receiverAddress: {
				houseNo: {
					value: '',
					errorMessage: null,
				},
				area: {
					value: '',
					errorMessage: null,
					ignore: true,
				},
				landmark: {
					value: '',
					errorMessage: null,
				},
				city: {
					value: '',
					errorMessage: null,
				},
				pincode: {
					value: '',
					errorMessage: null,
					ignore: true,
				},
			},
		};

		let updatedFormValues = {
			...formValues,
			dropTypeId: {
				value: '',
				selectedItem: {},
				errorMessage: null,
			},
			totalWeight: {value: ''},
			standard: {value: ''},
			general: {value: ''},
			shipmentValue: {value: ''},
			paymentType: {value: ''},
			paymentMode: {value: ''},
			desc: {value: ''},
		};
		if (!persistLocationInfo) {
			updatedFormValues = {...updatedFormValues, ...locationInfo};
		}
		setFormValues(updatedFormValues);
		setState((prev) => ({...prev, showRetryPopup: false, weightInfo: []}));
		setSelectedPaymentOption(null);
		setPaymentOptionsError(null);
	};
	const handleSubmit = (extraParams = {}) => {
		if (formSubmitInProgress) return;
		formSubmitInProgress = true;
		if (validateForm()) return (formSubmitInProgress = false);
		let weighCapExcedeed = false;
		if (
			bookingTypeMode === '1' &&
			//eslint-disable-next-line
			formValues.dropTypeId.value == '142' &&
			((bookingConfig && bookingConfig.maxWeight) || MAX_ACTUAL_WEIGHT)
		) {
			const weightCap = parseInt((bookingConfig && bookingConfig.maxWeight) || MAX_ACTUAL_WEIGHT);
			if (weightCap && weightCap > 0) {
				formValues.fareReq.weightInfo.forEach((item) => {
					if (parseInt(item.actualWeight) > weightCap) weighCapExcedeed = true;
				});
			}
		}
		if (weighCapExcedeed) {
			alert(
				`For Door Delivery Weight should not exceed ${
					(bookingConfig && bookingConfig.maxWeight) || MAX_ACTUAL_WEIGHT
				}KG per Piece`
			);
			formSubmitInProgress = false;
			console.log('formSubmitInProgress', formSubmitInProgress);

			return true;
		}
		if (!state.articleImage) {
			alert('Please add article image');
			formSubmitInProgress = false;
			console.log('formSubmitInProgress', formSubmitInProgress);
			return true;
		}

		if (showPaymentOptions && (!selectedPaymentOption || !selectedPaymentOption.topupType)) {
			return setPaymentOptionsError('Please select payment option!');
		} else {
			setPaymentOptionsError(null);
		}

		if (!state.showOverView) {
			formSubmitInProgress = false;
			console.log('formSubmitInProgress', formSubmitInProgress, state.showOverView, state.shipmentAlert);
			setState((prev) => ({
				...prev,
				shipmentAlert: true,
				showOverView: true,
			}));
			return;
		}

		let requestObject = {};
		requestObject.bookingWightInfoList = [];
		requestObject.stockNo = state.stockNo;
		requestObject.bookedDate = state.txtEffectiveDate;
		requestObject.cargoTypeId = formValues.cargoTypeId.selectedItem.id;
		requestObject.startPlaceID = formValues.sourceCounter.value;
		requestObject.endPlaceID = formValues.destinationCounter.value;
		requestObject.weight = formValues.consigmentWeight;
		requestObject.length = state.length;
		requestObject.breadth = state.breadth;
		requestObject.height = state.height;
		requestObject.totalDistance = transhipmentState.distanceResponse.totalDistance;
		requestObject.intraStateFlag = '0';
		requestObject.fromName = formValues.fromName.value;
		requestObject.toName = formValues.toName.value;
		requestObject.fromMobile = formValues.fromMobile.value;
		requestObject.toMobile = formValues.toMobile.value;
		requestObject.email = formValues.fromEmail.value;
		requestObject.gstinNumber = formValues.fromGstin.value || '';
		requestObject.description = formValues.desc.value;
		requestObject.availId = state.availId || '';
		requestObject.optPacking = packaging.isCoverPackaging ? '1' : '0';
		requestObject.optPlasticPacking = packaging.isPlasticPackaging ? '1' : '0';
		requestObject.senderHouseNo = formValues.senderAddress.houseNo.value;
		requestObject.senderLandmark = formValues.senderAddress.landmark.value;
		requestObject.senderCity = formValues.senderAddress.city.value;
		requestObject.senderState = formValues.sourceState.value;
		requestObject.senderArea = formValues.senderAddress.area.value || '';
		requestObject.senderPinCode = formValues.senderAddress.pincode.value || '';
		requestObject.fromAddress = requestObject.senderHouseNo;
		requestObject.senderAreaCode = formValues.senderAddress.area?.selectedItem?.areaCode;

		requestObject.receiverHouseNo = formValues.receiverAddress.houseNo.value;
		requestObject.receiverLandmark = formValues.receiverAddress.landmark.value;
		requestObject.receiverCity = formValues.receiverAddress.city.value;
		requestObject.receiverState = formValues.destinationState.value;
		requestObject.receiverArea = formValues.receiverAddress.area.value;
		requestObject.receiverPinCode = formValues.receiverAddress.pincode.value;
		requestObject.toAddress = requestObject.receiverHouseNo;

		requestObject.isActive = 'Y';
		requestObject.referenceRouteIdList = transhipmentState.distanceResponse.referenceRouteIdList;
		requestObject.toEmail = formValues.toEmail.value;
		requestObject.receiverGstinNumber = formValues.toGstin.value;
		requestObject.dropTypeId = formValues.dropTypeId.value;
		requestObject.shipmentValue = formValues.shipmentValue.value;
		requestObject.carrierTypeId = formValues.carrierTypeId.selectedItem.id;
		requestObject.unit = state.unit;
		requestObject.paymentMode = formValues.paymentMode.value;
		requestObject.bookingWightInfoList = formValues.fareReq.weightInfo;
		requestObject.identityType = formValues.identityTypeId.value;
		requestObject.identityNumber = formValues.identityNumber.value;
		requestObject.bookingType = bookingTypeMode;
		requestObject.paymentType = formValues.paymentType.value;
		requestObject.pickUpTypeId = 132;
		requestObject.originalWeight = state.originalWeight;
		requestObject.totalAmount = fareRes.totalAmount;
		requestObject.preBookingId = '';
		requestObject.isWeighingMachine = state.isWeighingMachine;
		requestObject.pickUpDate = formValues.pickUpDate.value || '';

		if (showPaymentOptions) {
			const paymentRedirectUrl = `${bookingConfig.domainUrl}api/customer/customerPaymentHandler`;
			requestObject.payableAmount =
				// eslint-disable-next-line
				bookingConfig.paymentCollectType == '1' ? fareRes.totalAmount : bookingConfig.miniPickFareCollect;
			requestObject.pgPaymentType = selectedPaymentOption.topupType;
			requestObject.retUrlStr = paymentRedirectUrl;
		}
		requestObject.cargoDoorDeliveryDto = {
			pinCode: formValues.receiverAddress.pincode.value,
			areaCode: formValues.receiverAddress.area?.selectedItem?.areaCode,
			areaName: formValues.receiverAddress.area?.selectedItem?.areaName,
		};
		const formData = new FormData();
		formData.append('payload', JSON.stringify(requestObject));
		if (state.articleImage) {
			formData.append('articleImage', dataURIToBlob(state.articleImage), 'ArticleImage.png');
		}
		setState((prev) => ({...prev, isLoading: true}));
		ServiceInterceptor(
			'/api/customer',
			'/booking/saveBooking',
			'POST',
			formData,
			(res) => {
				formSubmitInProgress = false;
				if (!res.error && res.pgUrlStr) {
					window.location = res.pgUrlStr;
				} else if (!res.error && res.id) {
					setState((prev) => ({...prev, bookingRes: res, isLoading: false}));
					scrollIntoView('#booking-status');
					// handlePrint()
				} else {
					setState((prev) => ({
						...prev,
						isLoading: false,
						showRetryPopup: true,
					}));
					showSnackBar('error', res.message);
				}
			},
			(err) => {
				formSubmitInProgress = false;
				showSnackBar('error', err.message);
				setState((prev) => ({...prev, showRetryPopup: true}));
			},
			{'Content-Type': 'multipart/form-data'}
		);
	};
	const handleClose = (submitForm = false, extraParams = {}) => {
		setState((prev) => ({
			...prev,
			shipmentAlert: !prev.shipmentAlert,
			showOverView: submitForm,
		}));
		if (submitForm) {
			handleSubmit(extraParams);
		}
	};
	const disableDate = (date) => {
		const muiDate = new Date(date);
		const shouldDisableDates = bookingConfig?.advSlotBookingDays;
		let maxDate = new Date();
		maxDate.setDate(maxDate.getDate() + shouldDisableDates);
		return muiDate.getTime() >= maxDate.getTime();
	};
	const disableMonth = (date) => {
		const muiMonth = new Date(date);
		const today = new Date();
		const currentMonth = today.getMonth();
		const currentYear = today.getFullYear();
		const month = muiMonth.getMonth();
		const year = muiMonth.getFullYear();
		return year > currentYear || (year === currentYear && month > currentMonth + 1);
	};
	const fetchSlot = (date) => {
		const formatedDate = new Date(date).toISOString().split('T')[0].split('-').reverse().join('/');
		const updatedFormValues = {...formValues};
		updatedFormValues.pickUpDate.value = formatedDate;
		updatedFormValues.pickUpDate.errorMessage = null;
		setFormValues(updatedFormValues);
		fetchSlotById(formValues.senderAddress.area.selectedItem.placeId, formatedDate);
	};
	const columns = [];
	const columnsToShow = {
		carrierTypeName: 'Carrier Type',
		productTypeName: 'Product Type',
		subProductTypeName: 'Sub-Category Type',
		pieceTypeName: 'Type of Pieces',
		actualWeight: 'Actual Weight ',
		totalWeight: 'Total Weight',
		noOfpiece: 'No of Pieces',
		length: 'Lenght(CM)',
		breadth: 'Width(CM)',
		height: 'Height(CM)',
		action: 'Action',
	};
	state &&
		state.weightInfo &&
		state.weightInfo.length > 0 &&
		//eslint-disable-next-line
		Object.keys(columnsToShow || {}).map((header) => {
			// if (state.weightInfo[0].hasOwnProperty(header))
			if (bookingTypeMode === '0' && header === 'subProductTypeName') return null;
			columns.push({
				name: header,
				label: (columnsToShow[header] || '').toUpperCase(),
				options: {
					filter: true,
					sort: true,
				},
			});
		});
	const options = {
		elevation: 0,
		responsive: 'stacked',
		selectableRows: 'none',
		print: false,
		pagination: false,
		search: false,
		download: false,
		filter: false,
		viewColumns: false,
	};

	const tableData =
		state.weightInfo &&
		state.weightInfo.map((weightInfoData, idx) => {
			weightInfoData.action = (
				<Grid container style={{flexWrap: 'nowrap'}}>
					<Tooltip title="Edit" placement="bottom">
						<EditIcon
							color="primary"
							onClick={() => handleWeightItemEdit(idx)}
							style={{cursor: 'pointer'}}
						/>
					</Tooltip>
					<Tooltip title="Delete" placement="bottom">
						<DeleteIcon
							color="secondary"
							onClick={() => handleWeightItemDelete(idx)}
							style={{cursor: 'pointer'}}
						/>
					</Tooltip>
				</Grid>
			);
			return weightInfoData;
		});

	return (
		<Grid container>
			<Grid container justifyContent="space-around">
				{snackbar && snackbar.message && (
					<Snackbars
						msg={snackbar.message}
						type={snackbar.type || 'info'}
						functype="custom"
						position={state.isMobile ? 'bottom' : 'right'}
					/>
				)}
				{canShowActiveCounters && (
					<Dialog open fullWidth maxWidth="xl" onClose={() => setCanShowActiveCounters(false)}>
						<DialogContent style={isMobile ? {overflow: 'unset'} : {overflow: 'hidden'}}>
							<CustomerActiveCounter isMobile={isMobile} close={setCanShowActiveCounters} />
						</DialogContent>
					</Dialog>
				)}

				<Grid container>
					{bookingConfig && bookingConfig.loginText1 && (
						<Grid item xs={12} style={{marginTop: '1rem'}}>
							{/* <Marquee message={} mode="smooth" /> */}
							<Typography color="textPrimary" align="center">
								{bookingConfig.loginText1}
							</Typography>
						</Grid>
					)}
					{bookingConfig && bookingConfig.bookingTypeList && bookingConfig.bookingTypeList.length > 0 && (
						<Grid item xs={12} style={currentStep === 1 ? {display: 'initial'} : {display: 'none'}}>
							<Card style={{margin: '2rem 1rem 1rem'}}>
								<CardContent>
									<Grid container alignItems="center" style={{gap: '1rem'}}>
										<FormControl variant="outlined" className={classes.formControl}>
											<InputLabel htmlFor="outlined-Booking-native-simple">Booking</InputLabel>
											<Select
												native
												value={bookingTypeMode}
												onChange={handleDropDownChange}
												label="Booking"
												inputProps={{
													name: 'Booking',
													id: 'outlined-Booking-native-simple',
												}}>
												{bookingConfig.bookingTypeList.map((item, index) => (
													<option value={index} key={`booking-type-${index}`}>
														{item.title}
													</option>
												))}
											</Select>
										</FormControl>

										<Typography variant="body1">
											{
												(
													bookingConfig.bookingTypeList.find(
														(_, index) => Number(bookingTypeMode) === index
													) || {}
												).description
											}
										</Typography>
									</Grid>
								</CardContent>
							</Card>
						</Grid>
					)}
					<Grid item lg={12}>
						<Grid container>
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								style={currentStep === 2 ? {padding: '1rem', display: 'initial'} : {display: 'none'}}>
								<Card>
									<CardContent style={{padding: '16px', paddingBottom: '32px'}}>
										<Grid container sm={12} justifyContent="space-between">
											<Grid item>
												<Typography variant="button" style={{color: '#6b6565'}}>
													{'Source Info'}
												</Typography>
											</Grid>
											<Grid item>
												<Button onClick={onInfoClick} color="primary" variant="text">
													{'available active counters'}
												</Button>
												{/* <InfoIcon fontSize='8px' color='primary' style={{cursor:'pointer'}} onClick={onInfoClick} /> */}
											</Grid>
											<Divider
												variant="inset"
												component="p"
												style={{
													width: '100%',
													marginLeft: '0px',
													marginBottom: '1rem',
												}}
											/>
										</Grid>
										<CardContent style={{padding: '0px', paddingBottom: '1rem'}}>
											<Grid container lg={12} xs={12} sm={12} md={12}>
												<Grid
													lg={6}
													xs={12}
													sm={12}
													md={12}
													spacing={2}
													style={{marginTop: '0px'}}>
													{/* Place search */}
													<Grid container alignItems="center">
														{bookingConfig &&
															bookingConfig.searchMapEnabled &&
															!isLocationEnabled && (
																<Grid item xs={12} lg={6} style={{padding: '0 0.5rem'}}>
																	<Autocomplete
																		options={PlaceList || []}
																		getOptionLabel={(option) => {
																			return (
																				(option && option.display_name) || ''
																			);
																		}}
																		renderInput={(params) => (
																			<TextField
																				{...params}
																				required={true}
																				label="Enter Location"
																				size="small"
																				variant="outlined"
																				error={
																					formValues.sourceLocation
																						.errorMessage
																						? true
																						: false
																				}
																				helperText={
																					formValues.sourceLocation
																						.errorMessage
																				}
																			/>
																		)}
																		inputValue={
																			formValues.sourceLocation.value || ''
																		}
																		onChange={(_, selectedItem) =>
																			handleAutoCompleteSelect(
																				'sourceLocation',
																				selectedItem,
																				selectedItem
																			)
																		}
																		onInputChange={(event, newInputValue) => {
																			fetchPlaceList(
																				event,
																				newInputValue,
																				'sourceLocation'
																			);
																		}}
																		fontSize="13px"
																		loading={isFetchingLocationsList}
																		// disabled={!formValues.sourceCounter.value}
																	/>
																</Grid>
															)}
														{isLocationEnabled && (
															<Grid container>
																<Grid item xs={12} md={6} style={{padding: '0 0.5rem'}}>
																	<Autocomplete
																		fullWidth
																		options={sourceFilteredAreaList || []}
																		renderOption={(props, option) => {
																			return (
																				<li
																					{...props}
																					key={props[`data-option-index`]}>
																					{option.areaName}
																				</li>
																			);
																		}}
																		getOptionLabel={(option) => {
																			return (option && option.areaName) || '';
																		}}
																		renderInput={(params) => (
																			<TextField
																				{...params}
																				required
																				label="Area"
																				size="small"
																				variant="outlined"
																				error={
																					formValues.senderAddress.area
																						.errorMessage
																						? true
																						: false
																				}
																				helperText={
																					formValues.senderAddress.area
																						.errorMessage
																				}
																			/>
																		)}
																		inputValue={
																			formValues.senderAddress.area.value || ''
																		}
																		onChange={(_, selectedItem) =>
																			handleAutoCompleteSelect(
																				'sourceArea',
																				selectedItem && selectedItem.areaCode,
																				selectedItem
																			)
																		}
																		value={
																			formValues.senderAddress.area
																				.selectedItem || {}
																		}
																		onInputChange={(event, newInputValue) => {
																			onAreaChange(
																				event,
																				newInputValue,
																				'source'
																			);
																		}}
																		noOptionsText="Currently not serving this area, please click on above AVAILABLE ACTIVE COUTNER link for available areas"
																		fontSize="13px"
																	/>
																</Grid>
																<Grid item xs={12} md={6} style={{padding: '0 0.5rem'}}>
																	<Autocomplete
																		options={state.sourcePincodeList || []}
																		getOptionLabel={(option) => {
																			return option || '';
																		}}
																		renderInput={(params) => (
																			<TextField
																				{...params}
																				required={true}
																				label="Pincode"
																				size="small"
																				variant="outlined"
																				error={
																					formValues.senderAddress.pincode
																						.errorMessage
																						? true
																						: false
																				}
																				helperText={
																					formValues.senderAddress.pincode
																						.errorMessage
																				}
																			/>
																		)}
																		inputValue={
																			formValues.senderAddress.pincode.value || ''
																		}
																		value={
																			formValues.senderAddress.pincode.value || ''
																		}
																		// onChange={(_, selectedItem) => handleAutoCompleteSelect('pincode', selectedItem && selectedItem.pincode, selectedItem)}
																		onInputChange={(event, newInputValue) => {
																			fetchPincodeList(
																				event,
																				newInputValue,
																				'source'
																			);
																		}}
																		fontSize="13px"
																		// disabled={!formValues.destinationCounter.value}
																	/>
																</Grid>
															</Grid>
														)}
														{bookingConfig &&
															bookingConfig.searchMapEnabled &&
															!isLocationEnabled && (
																<Grid item xs={12} lg={6}>
																	<Button
																		variant="outlined"
																		onClick={() =>
																			onLocationClick('manualLocation')
																		}>
																		{' '}
																		I have an another Location{' '}
																	</Button>
																</Grid>
															)}
														{bookingConfig &&
															bookingConfig.searchMapEnabled &&
															isLocationEnabled && (
																<Grid
																	item
																	xs={12}
																	lg={6}
																	style={{marginLeft: '0.5rem'}}>
																	<Button
																		variant="outlined"
																		onClick={() => onLocationClick('autoLocation')}>
																		{' '}
																		Fetch Pickup Location{' '}
																	</Button>
																</Grid>
															)}
													</Grid>

													{/* State */}
													<Grid item xs={12} style={{padding: '0 0.5rem'}}>
														<Autocomplete
															options={state.statesList || []}
															getOptionLabel={(option) => {
																return (option && option.stateName) || '';
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	required={!isLocationEnabled}
																	label="Source State"
																	size="small"
																	variant="outlined"
																	error={
																		formValues.sourceState.errorMessage
																			? true
																			: false
																	}
																	helperText={formValues.sourceState.errorMessage}
																/>
															)}
															value={formValues.sourceState.selectedItem || undefined}
															onChange={(_, selectedItem) =>
																handleAutoCompleteSelect(
																	'sourceState',
																	selectedItem && selectedItem.stateCode,
																	selectedItem
																)
															}
															fontSize="13px"
															disabled={isLocationEnabled}
														/>
													</Grid>

													{/* District */}
													{bookingConfig &&
														bookingConfig.searchMapEnabled &&
														!isLocationEnabled && (
															<Grid item xs={12} style={{padding: '0 0.5rem'}}>
																<Autocomplete
																	options={districtList.copyDistrict || []}
																	getOptionLabel={(option) => {
																		return (option && option.districtName) || '';
																	}}
																	renderInput={(params) => (
																		<TextField
																			{...params}
																			required={true}
																			label="Source District"
																			size="small"
																			variant="outlined"
																			error={
																				formValues.sourceDistrict.errorMessage
																					? true
																					: false
																			}
																			helperText={
																				formValues.sourceDistrict.errorMessage
																			}
																		/>
																	)}
																	value={
																		formValues.sourceDistrict.selectedItem ||
																		undefined
																	}
																	onChange={(_, selectedItem) =>
																		handleAutoCompleteSelect(
																			'sourceDistrict',
																			selectedItem && selectedItem.districtId,
																			selectedItem
																		)
																	}
																	fontSize="13px"
																	disabled={!formValues.sourceState.value}
																/>
															</Grid>
														)}
													{/* Counter */}
													<Grid item xs={12} style={{padding: '0 0.5rem'}}>
														<TextField
															size="small"
															fullWidth
															inputProps={{maxLength: 120}}
															autoComplete="off"
															variant="outlined"
															label="Pickup Counter"
															name="sourceCounter"
															value={formValues.sourceCounter.displayName}
															InputLabelProps={{
																shrink: formValues.sourceCounter.displayName
																	? true
																	: false,
															}}
															disabled={true}
														/>
													</Grid>
													{/* Calender */}
													<Grid className="bookings-calender" style={{padding: '0 0.5rem'}}>
														<LocalizationProvider dateAdapter={AdapterDayjs}>
															<DatePicker
																defaultValue={dayjs(new Date())}
																slotProps={{
																	textField: {
																		size: 'small',
																		disabled: isMobile
																			? false
																				? false
																				: !formValues.senderAddress.area.value
																			: true,
																		name: 'pickUpDate',
																		error: formValues.pickUpDate.errorMessage
																			? true
																			: false,
																		helperText: formValues.pickUpDate.errorMessage,
																	},
																}}
																label="Pickup Date"
																disablePast
																disabled={!formValues.senderAddress.area.value}
																shouldDisableDate={disableDate}
																shouldDisableMonth={disableMonth}
																onChange={fetchSlot}
															/>
														</LocalizationProvider>
													</Grid>
												</Grid>
												<Grid lg={6} xs={12} sm={12} md={12}>
													{/* Source Mobile number */}
													<Grid item xs={12} style={{padding: '0 0.5rem'}}>
														<TextField
															required={true}
															id="fromMobile"
															fontSize="13px"
															variant="outlined"
															size="small"
															label="Mobile"
															placeholder="Mobile"
															type="number"
															fullWidth
															name="fromMobile"
															value={formValues.fromMobile.value || ''}
															autoComplete="off"
															error={formValues.fromMobile.errorMessage}
															helperText={formValues.fromMobile.errorMessage}
															inputProps={{maxLength: 10}}
															disabled={true}
														/>
													</Grid>
													{/* Source Name */}
													<Grid item xs={12} style={{padding: '0 0.5rem'}}>
														<TextField
															required={true}
															id="fromName"
															label={'Name'}
															variant="outlined"
															size="small"
															placeholder="Name"
															fullWidth
															disabled={false}
															name="fromName"
															value={formValues.fromName.value || ''}
															onChange={(e) =>
																handleChange(e, {
																	inputType: 'string',
																	maxLength: CONSTRAINT_USERNAME_MAX_LENGTH,
																})
															}
															error={formValues.fromName.errorMessage}
															helperText={formValues.fromName.errorMessage}
															inputProps={{maxLength: 50}}
															autoComplete="off"
														/>
													</Grid>
													{/* Source Email */}
													<Grid item xs={12} style={{padding: '0 0.5rem'}}>
														<TextField
															required={true}
															id="fromEmail"
															size="small"
															variant="outlined"
															label={'Email'}
															placeholder="Email"
															name="fromEmail"
															style={{minWidth: '100%'}}
															value={formValues.fromEmail.value || ''}
															onChange={(e) =>
																handleChange(e, {
																	maxLength: CONSTRAINT_EMAIL_MAX_LENGTH,
																})
															}
															error={formValues.fromEmail.errorMessage}
															helperText={formValues.fromEmail.errorMessage}
															fontSize="13px"
															inputProps={{maxLength: 50}}
															autoComplete="off"
														/>
													</Grid>
													{/* Source Gstin */}
													<Grid item xs={12} style={{padding: '0 0.5rem'}}>
														<TextField
															id="fromGstin"
															name="fromGstin"
															size="small"
															variant="outlined"
															label={'GSTIN'}
															placeholder="GSTIN"
															style={{minWidth: '100%'}}
															value={formValues.fromGstin.value || ''}
															onChange={handleChange}
															error={formValues.fromGstin.errorMessage}
															errorMessage={formValues.fromGstin.errorMessage}
															fontSize="13px"
														/>
													</Grid>
												</Grid>
												{/* slot */}
												{state.slotList?.length > 0 && (
													<Grid
														lg={12}
														container
														justifyContent={'flex-start'}
														alignItems={'center'}>
														<Grid xs={12} lg={12}>
															<Typography variant="h6">Pick up Slots</Typography>
														</Grid>

														{state.slotList?.map((item, index) => {
															return (
																<Grid
																	key={index}
																	style={{display: 'inline-block', margin: '10px'}}>
																	<Tooltip
																		title={
																			<>
																				<div>
																					Slot Timings: {item.startTime} -{' '}
																					{item.endTime}
																				</div>
																			</>
																		}>
																		<Button
																			onClick={() =>
																				handleButtonClick(index, item.availId)
																			}
																			variant={
																				selectedButton === index
																					? 'contained'
																					: 'outlined'
																			}
																			color={
																				selectedButton === index
																					? 'primary'
																					: 'secondary'
																			}>
																			{selectedButton === index && (
																				<IconButton
																					style={{
																						padding: '0',
																						marginRight: '2px',
																						paddingBottom: '2px',
																						color: 'white',
																					}}
																					onClick={() =>
																						handleButtonClick(
																							index,
																							item.availId
																						)
																					}
																					color={
																						selectedButton === index
																							? 'primary'
																							: 'secondary'
																					}>
																					<CheckIcon />
																				</IconButton>
																			)}
																			{`${item.startTime} - ${item.endTime} `}
																		</Button>
																	</Tooltip>
																</Grid>
															);
														})}
													</Grid>
												)}
											</Grid>
											<CustomerAddress
												title="Address"
												config={bookingConfig && bookingConfig.maxKmAllowed}
												{...formValues.senderAddress}
												onChange={(event, validationObj) =>
													handleAddressChange(event, 'sender', validationObj)
												}
												name="sender"
												isMandatory={true}
												style={{margin: '20px -5px', border: 'none'}}
												statesList={state.statesList}
												sourceCounter={CounterList}
												formValues={{...formValues}}
												handleAutoCompleteSelect={handleAutoCompleteSelect}
												setFormValues={setFormValues}
											/>
											{identityTypeList && (
												<Identity
													isMandatory
													identityList={identityTypeList}
													identityTypeId={formValues.identityTypeId}
													identityNumber={formValues.identityNumber}
													onChange={handleIdentityChange}
													handleInvalidId={handleInvalidId}
													style={{border: 'none'}}
												/>
											)}
											{formValues.sourceState?.selectedItem?.arearDistance >= 0 && (
												<Typography margin={'12px'}>
													Sender Area distance :{' '}
													{formValues.sourceState?.selectedItem?.arearDistance} Km
												</Typography>
											)}
										</CardContent>
									</CardContent>
								</Card>
							</Grid>
							{/* Destination */}
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								style={currentStep === 3 ? {padding: '1rem', display: 'initial'} : {display: 'none'}}>
								<Card>
									<CardContent style={{padding: '16px', paddingBottom: '32px'}}>
										<Grid item lg={12} style={{width: '100%'}}>
											<Typography variant="button" style={{color: '#6b6565'}}>
												{'Destination Info'}
											</Typography>
											<Divider
												variant="inset"
												component="p"
												style={{
													width: '100%',
													marginLeft: '0px',
													marginBottom: '1rem',
												}}
											/>
										</Grid>
										<CardContent style={{padding: '0px', paddingBottom: '1rem'}}>
											<Grid container>
												<Grid item xs={12} md={6} style={{padding: '0 0.5rem'}}>
													<Autocomplete
														fullWidth
														options={filteredAreaList || []}
														renderOption={(props, option) => {
															return (
																<li {...props} key={props[`data-option-index`]}>
																	{option.areaName}
																</li>
															);
														}}
														getOptionLabel={(option) => {
															return (option && option.areaName) || '';
														}}
														renderInput={(params) => (
															<TextField
																{...params}
																required
																label="Area"
																size="small"
																variant="outlined"
																error={
																	formValues.receiverAddress.area.errorMessage
																		? true
																		: false
																}
																helperText={
																	formValues.receiverAddress.area.errorMessage
																}
															/>
														)}
														inputValue={formValues.receiverAddress.area.value || ''}
														onChange={(_, selectedItem) =>
															handleAutoCompleteSelect(
																'area',
																selectedItem && selectedItem.areaCode,
																selectedItem
															)
														}
														value={formValues.receiverAddress.area.selectedItem || {}}
														onInputChange={(event, newInputValue) => {
															onAreaChange(event, newInputValue, 'destination');
														}}
														fontSize="13px"
													/>
												</Grid>
												<Grid item xs={12} md={6} style={{padding: '0 0.5rem'}}>
													<Autocomplete
														options={state.areaPincodeList || []}
														getOptionLabel={(option) => {
															return option || '';
														}}
														renderInput={(params) => (
															<TextField
																{...params}
																required={true}
																label="Pincode"
																size="small"
																variant="outlined"
																error={
																	formValues.receiverAddress.pincode.errorMessage
																		? true
																		: false
																}
																helperText={
																	formValues.receiverAddress.pincode.errorMessage
																}
															/>
														)}
														inputValue={formValues.receiverAddress.pincode.value || ''}
														value={formValues.receiverAddress.pincode.value || ''}
														// onChange={(_, selectedItem) => handleAutoCompleteSelect('pincode', selectedItem && selectedItem.pincode, selectedItem)}
														onInputChange={(event, newInputValue) => {
															fetchPincodeList(event, newInputValue, 'destination');
														}}
														fontSize="13px"
														// disabled={!formValues.destinationCounter.value}
													/>
												</Grid>
											</Grid>
											{/*Destination State */}
											<Grid item xs={12} style={{padding: '0 0.5rem'}}>
												<Autocomplete
													disabled={true}
													options={state.statesList || []}
													fullWidth
													getOptionLabel={(option) => {
														return (option && option.stateName) || '';
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Destination State"
															size="small"
															variant="outlined"
															error={
																formValues.destinationState.errorMessage ? true : false
															}
															helperText={formValues.destinationState.errorMessage}
														/>
													)}
													value={formValues.destinationState.selectedItem || undefined}
													onChange={(_, selectedItem) =>
														handleAutoCompleteSelect(
															'destinationState',
															selectedItem && selectedItem.stateCode,
															selectedItem
														)
													}
													fontSize="13px"
													// disabled={!formValues.sourceLocation.value}
												/>
											</Grid>
											{/*Destination Counter */}
											<Grid item xs={12} style={{padding: '0 0.5rem'}}>
												<Autocomplete
													fullWidth
													options={[]}
													getOptionLabel={(option) => {
														return (option && option.placeName) || '';
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Counter/City"
															size="small"
															variant="outlined"
															error={
																formValues.destinationCounter.errorMessage
																	? true
																	: false
															}
															helperText={formValues.destinationCounter.errorMessage}
														/>
													)}
													value={formValues.destinationCounter.selectedItem || undefined}
													onChange={(_, selectedItem) =>
														handleAutoCompleteSelect(
															'destinationCounter',
															selectedItem && selectedItem.placeId,
															selectedItem
														)
													}
													fontSize="13px"
													disabled={true}
												/>
											</Grid>
											{/* Destination Mobile number */}
											<Grid item xs={12} style={{padding: '0 0.5rem', marginTop: '.2rem'}}>
												<TextField
													required={true}
													id="toMobile"
													fontSize="13px"
													variant="outlined"
													size="small"
													label="Mobile"
													placeholder="Mobile"
													type="number"
													fullWidth
													name="toMobile"
													value={formValues.toMobile.value || ''}
													onChange={(e) =>
														handleChange(e, {
															inputType: 'number',
															maxLength: 10,
														})
													}
													autoComplete="off"
													error={formValues.toMobile.errorMessage}
													helperText={formValues.toMobile.errorMessage}
													inputProps={{maxLength: 10}}
													InputProps={{
														startAdornment: (
															<InputAdornment position="start">+91</InputAdornment>
														),
														endAdornment: clearReceiverAddress ? (
															<InputAdornment position="end">
																<ClearIcon
																	color="primary"
																	name="clearSender"
																	style={{cursor: 'pointer'}}
																	onClick={(event) => handleClearAddress('sender')}
																/>
															</InputAdornment>
														) : (
															''
														),
													}}
												/>
											</Grid>
											{/* Destination Name */}
											<Grid item xs={12} style={{padding: '0 0.5rem'}}>
												<TextField
													required={true}
													id="toName"
													label={'Name'}
													variant="outlined"
													size="small"
													placeholder="Name"
													fullWidth
													disabled={false}
													name="toName"
													value={formValues.toName.value || ''}
													onChange={(e) =>
														handleChange(e, {
															inputType: 'string',
															maxLength: CONSTRAINT_USERNAME_MAX_LENGTH,
														})
													}
													error={formValues.toName.errorMessage}
													helperText={formValues.toName.errorMessage}
													inputProps={{maxLength: 50}}
													autoComplete="off"
												/>
											</Grid>
											{/* Destination Email */}
											<Grid item xs={12} style={{padding: '0 0.5rem'}}>
												<TextField
													required={false}
													id="toEmail"
													size="small"
													variant="outlined"
													label={'Email'}
													placeholder="Email"
													name="toEmail"
													fullWidth
													value={formValues.toEmail.value || ''}
													onChange={(e) =>
														handleChange(e, {
															maxLength: CONSTRAINT_EMAIL_MAX_LENGTH,
														})
													}
													error={formValues.toEmail.errorMessage}
													helperText={formValues.toEmail.errorMessage}
													fontSize="13px"
													inputProps={{maxLength: 50}}
													autoComplete="off"
												/>
											</Grid>
											{/* Destination Gstin */}
											<Grid item xs={12} style={{padding: '0 0.5rem'}}>
												<TextField
													id="toGstin"
													name="toGstin"
													size="small"
													variant="outlined"
													label={'GSTIN'}
													placeholder="GSTIN"
													fullWidth
													value={formValues.toGstin.value || ''}
													onChange={handleChange}
													error={formValues.toGstin.errorMessage}
													errorMessage={formValues.toGstin.errorMessage}
													fontSize="13px"
												/>
											</Grid>
											<CustomerAddress
												title="Address"
												{...formValues.receiverAddress}
												config={bookingConfig && bookingConfig.maxKmAllowed}
												name="receiver"
												onChange={(event, validationObj) =>
													handleAddressChange(event, 'receiver', validationObj)
												}
												style={{margin: '20px -5px', border: 'none'}}
												statesList={state.statesList}
												sourceCounter={CounterList}
												formValues={{...formValues}}
												state={{...state}}
												handleAutoCompleteSelect={handleAutoCompleteSelect}
												isMandatory={true}
												pickupDeliveryElement={
													jsonData.dropTypeJson && (
														<Autocomplete
															size="small"
															id={'dropTypeId'}
															options={jsonData.dropTypeJson.filter((item) => {
																if (
																	// eslint-disable-next-line
																	formValues.area.selectedItem?.isCargoDelivery ==
																		'0' &&
																	// eslint-disable-next-line
																	item.id == DOOR_DELIVERY
																)
																	return false;
																return true;
															})}
															getOptionLabel={(option) => option.name || ''}
															onChange={(event, option) =>
																handleAutoCompleteSelect(
																	'dropTypeId',
																	option && option.id,
																	option
																)
															}
															name={'Delivery'}
															margin="dense"
															value={
																(formValues && formValues.dropTypeId.selectedItem) ||
																undefined
															}
															defaultValue={
																jsonData.dropTypeJson ? jsonData.dropTypeJson[1] : ''
															}
															clearOnEscape={true}
															renderInput={(params) => (
																<TextField
																	name={'dropTypeId'}
																	required={true}
																	variant="outlined"
																	error={
																		formValues.dropTypeId &&
																		formValues.dropTypeId.errorMessage
																			? true
																			: false
																	}
																	helperText={
																		formValues.dropTypeId
																			? formValues.dropTypeId.errorMessage
																			: ''
																	}
																	{...params}
																	label={'Delivery'}
																	fullWidth
																	autoComplete="off"
																/>
															)}
														/>
													)
												}
												setFormValues={setFormValues}
											/>
											{transhipmentState.distanceResponse &&
												transhipmentState.distanceResponse.referenceRouteIdList &&
												transhipmentState.distanceResponse.referenceRouteIdList.length > 0 && (
													<Grid item xs={12} md={6} lg={12}>
														<Typography variant="body1" bgcolor={'#ebebeb'} padding={'5px'}>
															<span>Route Name :</span>
															{transhipmentState.distanceResponse.routeName}
														</Typography>
														<Table size="small" style={{border: '1px solid #e0e0e0'}}>
															<TableHead>
																<TableRow>
																	<TableCell>Route Code</TableCell>
																	<TableCell align="right">Distance</TableCell>
																</TableRow>
															</TableHead>
															<TableBody>
																{transhipmentState.distanceResponse.referenceRouteIdList.map(
																	(row) => (
																		<TableRow key={row.routeCode}>
																			<Tooltip
																				title={row.routeCode}
																				placement="bottom-start">
																				<TableCell component="th">
																					{row.routeInfo}
																				</TableCell>
																			</Tooltip>
																			<TableCell align="right">{`${row.distance} KM`}</TableCell>
																		</TableRow>
																	)
																)}
															</TableBody>
														</Table>
													</Grid>
												)}
											{formValues.destinationState?.selectedItem?.arearDistance >= 0 && (
												<Typography margin={'12px'}>
													Receiver Area distance :{' '}
													{formValues.destinationState?.selectedItem?.arearDistance} Km
												</Typography>
											)}
										</CardContent>
									</CardContent>
								</Card>
							</Grid>
						</Grid>
						{/* Add transhipment */}
						{/* <Grid item xs={12} sm={12} md={12} lg={12} style={{ padding: '0 1rem' }}>
                            <Paper elevation={0} style={{ padding: "1.0rem", border: "1px solid #0000001f", borderRadius: "6px", marginTop: "10px", width: '100%' }}>
                                <Grid container spacing={2} style={{ paddingTop: '0px' }}>
                                    <Grid item xs={12}>
                                        <Typography variant="button" style={{ color: '#6b6565' }}>Additional Transshipment (if required)</Typography>
                                        <Divider variant="inset" component="p" style={{ width: '100%', marginLeft: '0px' }} />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        {new Array(transhipmentState.transshipmentCount).fill(null).map((item, index) => {
                                            return (
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        options={transhipmentState.transshipmentList || []}
                                                        getOptionLabel={option => option.name || ""}
                                                        onChange={(event, option) => handleTransshipmentChange(index, option)}
                                                        value={transhipmentState.transshipment && transhipmentState.transshipment[index] && transhipmentState.transshipment[index].selectedItem || undefined}
                                                        disabled={transhipmentState.disableTransshipment}
                                                        size="small"
                                                        clearOnEscape={true}
                                                        renderInput={params => (
                                                            <TextField variant="outlined"
                                                                error={transhipmentState.errors && transhipmentState.errors['paymentMode'] ? true : false}
                                                                helperText={transhipmentState.errors ? transhipmentState.errors['paymentMode'] : ""} {...params} label={`Transshipment Place ${index + 1}`} size="small" fullWidth autoComplete="off" />
                                                        )}
                                                    />
                                                </Grid>
                                            );
                                        })}
                                        <Button
                                            id="add-transshipment"
                                            variant="contained"
                                            color="primary"
                                            onClick={fetchTransshipmentPoints}
                                            style={{ marginTop: '0.5rem' }}
                                        // disabled={transhipmentState.disableTransshipment || transhipmentState.isNomanPlace == '1' || transhipmentState.fetchingTransshipment || transhipmentState.transshipmentCount > 4 || (transhipmentState.transshipmentCount > 0 && (!transhipmentState.transshipment[transhipmentState.transshipmentCount - 1] || !transhipmentState.transshipment[transhipmentState.transshipmentCount - 1].value))}
                                        >
                                            Add Transshipment
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        {transhipmentState.distanceResponse && transhipmentState.distanceResponse.suggestedRouteNames && (
                                            <React.Fragment>
                                                <Typography color="textPrimary">{`Suggested Transshipment Points:`}</Typography>
                                                <Typography color="textSecondary">{transhipmentState.distanceResponse.suggestedRouteNames}</Typography>
                                            </React.Fragment>
                                        )}
                                    </Grid>
                                    {transhipmentState.distanceResponse && transhipmentState.distanceResponse.referenceRouteIdList && transhipmentState.distanceResponse.referenceRouteIdList.length > 0 && (
                                        <Grid item xs={12} md={6} lg={4}>
                                            <Table size="small" style={{ border: '1px solid #e0e0e0' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Route Code</TableCell>
                                                        <TableCell align="right">Distance</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {transhipmentState.distanceResponse.referenceRouteIdList.map((row) => (
                                                        <TableRow key={row.routeCode}>
                                                            <Tooltip title={row.routeCode} placement="bottom-start">
                                                                <TableCell component="th">{row.routeInfo}</TableCell>
                                                            </Tooltip>
                                                            <TableCell align="right">{`${row.distance} KM`}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </Grid>
                                    )}
                                </Grid>
                            </Paper>
                        </Grid> */}
						{/* WEIGHT INFO */}
						<Grid
							item
							xs={12}
							sm={12}
							md={12}
							lg={12}
							style={currentStep === 4 ? {padding: '1rem', display: 'initial'} : {display: 'none'}}
							id="customer-weightInfo">
							<Paper
								elevation={0}
								style={{
									padding: '1.0rem',
									border: '1px solid #0000001f',
									borderRadius: '6px',
									marginTop: '10px',
								}}>
								<Grid container alignContent="center" spacing={2} style={{paddingBottom: '15px'}}>
									{bookingTypeMode === '1' &&
										weightInfoFormObj.map((addParam) => {
											return addField(addParam);
										})}
									{bookingTypeMode === '0' &&
										CourierWeightInfoFormObj.map((addParam) => {
											if (bookingTypeMode === '0' && addParam.column === 'subProductTypeId')
												return null;
											if (addParam.column === 'unit') addParam.disabled = true;
											return addField(addParam);
										})}
									{volumetricCarrierTypeIds.includes(
										formValues.carrierTypeId &&
											formValues.carrierTypeId.selectedItem &&
											formValues.carrierTypeId.selectedItem.id
									) && (
										<Fragment>
											{addField({
												heading: `Volumetric Weight in kg=Length X Breadth X Height / ${
													formValues.carrierTypeId.selectedItem.id ===
													CARRIER_TYPE_INSIDE_DICKEY
														? '2500'
														: '4000'
												}`,
												type: 'labelLine',
											})}
											{volumetricForm.map((addParam) => addField(addParam))}
										</Fragment>
									)}
									<Grid container justifyContent="flex-end">
										<Button
											variant="contained"
											color="primary"
											disabled={isCourier || !state.actualweight}
											onClick={handleAddItem}
											startIcon={<AddCircleIcon />}>
											<span>
												{`${state.editWeightInfoIndex > -1 ? 'Update Weight' : 'Add Weight'}`}
											</span>
										</Button>
									</Grid>
								</Grid>
							</Paper>

							{state.weightInfo && state.weightInfo.length > 0 && (
								<Paper
									elevation={0}
									style={{
										padding: '1rem',
										borderRadius: '6px',
										marginTop: '1rem',
										width: state.isMobile ? 'calc(100vw - 1.5rem)' : '',
									}}>
									<Grid container style={{padding: '1rem'}} lg={12} md={4} sm={4}>
										<Box style={{width: '100%'}}>
											<MUIDataTable
												title=""
												data={tableData}
												columns={columns}
												options={options}
												style={{marignTop: '2rem'}}
											/>
										</Box>
									</Grid>
								</Paper>
							)}
						</Grid>
						{/* Payment mode */}
						<Grid
							item
							xs={12}
							sm={12}
							md={12}
							lg={12}
							style={currentStep === 5 ? {padding: '0 1rem', display: 'initial'} : {display: 'none'}}>
							<Paper
								elevation={0}
								xs={12}
								sm={12}
								md={12}
								lg={12}
								style={{
									padding: '1.0rem',
									border: '1px solid #0000001f',
									borderRadius: '6px',
									marginTop: '10px',
								}}>
								<Grid container>
									<Grid item xs={12} style={{padding: '0 0.5rem 1rem 0.5rem '}}>
										<Typography variant="button" style={{color: '#6b6565'}}>
											Booking
										</Typography>
										<Divider
											variant="inset"
											component="p"
											style={{width: '100%', marginLeft: '0px'}}
										/>
									</Grid>
									{/*
									<Grid xs={12} md={6} lg={3} xl={3} item style={{padding: '0 0.5rem 1rem 0.5rem '}}>
										<CustomSelect
											id={'paymentMode'}
											defaultValue={0}
											options={
												(jsonData.paymentModeJson &&
													jsonData.paymentModeJson.filter((item) =>
														(formValues['destinationCounter'].selectedItem &&
															formValues['destinationCounter'].selectedItem
																.isNomanPlace === '1') ||
														(formValues['destinationCounter'].selectedItem &&
															formValues['destinationCounter'].selectedItem
																.isTopayNotAllowed === '1') ||
														//eslint-disable-next-line
														formValues.dropTypeId.value == DOOR_DELIVERY
															? item.id !== PAYMENT_MODE_TO_PAY
															: true
													)) ||
												[]
											}
											getOptionLabel={(option) => option.name}
											onChange={(event, option) => handleChange(event)}
											value={formValues.paymentMode.value || ''}
											name="paymentMode"
											label={'Payment Type'}
											errorMessage={
												formValues.paymentType && formValues.paymentType.errorMessage
													? formValues.paymentType.errorMessage
													: ''
											}
										/>
									</Grid>
									<Grid xs={12} md={6} lg={3} xl={3} item style={{padding: '0 0.5rem 1rem 0'}}>
										<Autocomplete
											id={'paymentType'}
											options={jsonData.paymentTypeJson || []}
											getOptionLabel={(option) => option.name}
											onChange={(event, option) =>
												handleAutoCompleteSelect('paymentType', option.id, option)
											}
											disabled={Number(formValues.paymentMode.value) === PAYMENT_MODE_TO_PAY}
											name={'Payment Type'}
											size="small"
											value={formValues.paymentType.selectedItem || ''}
											fullWidth
											defaultValue={jsonData.paymentTypeJson ? jsonData.paymentTypeJson[0] : ''}
											clearOnEscape={true}
											renderInput={(params) => (
												<TextField
													name={'paymentType'}
													required={true}
													variant="outlined"
													error={
														formValues.paymentType && formValues.paymentType.errorMessage
															? true
															: false
													}
													helperText={formValues.paymentType.errorMessage}
													{...params}
													label={'Mode of Payment'}
													size="small"
													fullWidth
													autoComplete="off"
												/>
											)}
										/>
									</Grid>
									*/}
									<Grid xs={12} md={6} lg={3} xl={3} item style={{padding: '0 0.5rem 1rem 0 '}}>
										<TextField
											name={'shipmentValue'}
											value={formValues.shipmentValue.value}
											variant="outlined"
											size="small"
											disabled={false}
											id="shipmentValue"
											// defaultValue={this.state.preBookingDetails.shipmentValue}
											fullWidth
											required
											label={'Shipment Value'}
											onChange={(event) =>
												handleChange(event, {
													inputType: 'number',
													maxLength: bookingTypeMode === '0' ? 3 : 5,
													maxValue: bookingTypeMode === '0' ? 100 : 99999,
												})
											}
											InputProps={{
												startAdornment: <InputAdornment position="start">₹</InputAdornment>,
											}}
											error={formValues.shipmentValue.errorMessage ? true : false}
											helperText={formValues.shipmentValue.errorMessage}
											inputProps={{type: 'number'}}
											autoComplete="off"
										/>
									</Grid>
									<Grid item xs={12} md={6} lg={3} xl={3}>
										<TextField
											name={'desc'}
											value={(formValues['desc'] && formValues['desc'].value) || ''}
											variant="outlined"
											size="small"
											fullWidth
											label={'Packing Desc'}
											required={true}
											onChange={(event) =>
												handleChange(event, {
													maxLength: CONSTRAINT_BOOKING_DESC_MAX_LENGTH,
												})
											}
											error={formValues['desc'] && formValues['desc'].errorMessage ? true : false}
											helperText={formValues['desc'] && formValues['desc'].errorMessage}
											// inputProps={{ maxLength: addParam.maxlength }}
											autoComplete="off"
										/>
									</Grid>
									<Grid xs={12} md={6} lg={12} xl={3} item style={{padding: '0 0.5rem 1rem 0'}}>
										<Typography variant="h6" fontSize={'1em'} marginLeft={1}>
											Choose Packaging
										</Typography>
										<FormControlLabel
											control={
												<Checkbox
													checked={packaging.isCoverPackaging}
													onChange={() => handlePackagingChange('isCoverPackaging')}
													color="primary"
												/>
											}
											label="Cover Packaging"
											style={{
												marginLeft: '0',
												marginBottom: '-0.5rem',
												color: '#0c0a00',
											}}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={packaging.isPlasticPackaging}
													onChange={() => handlePackagingChange('isPlasticPackaging')}
													color="primary"
												/>
											}
											label="Plastic Wrapper Packaging"
											style={{
												marginLeft: '0',
												marginBottom: '-0.5rem',
												color: '#0c0a00',
											}}
										/>
									</Grid>
									<Divider
										variant="inset"
										component="p"
										style={{
											width: '100%',
											marginLeft: '0px',
										}}
									/>
									<Grid
										container
										justifyContent="space-between"
										alignItems="center"
										style={{margin: '0.5rem 0'}}>
										<Box>
											<FormControlLabel
												control={
													<Checkbox
														checked={isUserConsented}
														onChange={handleUserConsentChange}
														color="primary"
													/>
												}
												label="Original documents, cash, gold not allowed for booking"
												style={{
													marginLeft: '0',
													marginBottom: '-0.5rem',
													color: '#0c0a00',
												}}
											/>
											<br />
											<Checkbox
												checked={acceptedTermsAndConditions}
												onChange={() =>
													setAcceptedTermsAndConditions((isAccepted) => !isAccepted)
												}
												color="primary"
											/>
											<Link
												to="/customers/booking/termsAndConditions"
												target="_blank"
												style={{textDecoration: 'none'}}>
												<MUILink className="simple" underline="none">
													Accept Terms & Conditions
												</MUILink>
											</Link>
										</Box>
										<Button
											variant="contained"
											color="primary"
											onClick={(event) => showBookingFare(event, stateParams.addParams)}
											disabled={
												!transhipmentState.distanceResponse ||
												transhipmentState.distanceResponse.totalDistance === 0 ||
												!isUserConsented ||
												!acceptedTermsAndConditions
											}
											style={{
												paddingLeft: '1rem',
												paddingRight: '1rem',
												height: 'fit-content',
											}}
											size="medium">
											<span>Get Fares</span>
										</Button>
									</Grid>
								</Grid>
							</Paper>
							{/* {console.log(formValues.cargoTypeId)} */}
							{formValues && formValues.fareReq && formValues.showBooking && (
								<FareDetails
									handleFareCallback={handleFareCallback}
									url={'/api/customer'}
									weight={formValues.consigmentWeight}
									distanceResponse={transhipmentState.distanceResponse}
									type={'/booking'}
									formData={formValues && formValues.fareReq}
									table={{minWidth: '700'}}
									cargoTypeId={bookingTypeMode}
									productTypeId={formValues.cargoTypeId.selectedItem.id}
									extraParams={{isTempBooking: '1'}}></FareDetails>
							)}
						</Grid>

						<Grid container>
							{/* Image mode */}
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								style={currentStep === 6 ? {padding: '0 1rem', display: 'initial'} : {display: 'none'}}>
								<Paper
									elevation={0}
									xs={12}
									sm={12}
									md={12}
									lg={12}
									style={{
										padding: '1.0rem',
										border: '1px solid #0000001f',
										borderRadius: '6px',
										marginTop: '10px',
									}}>
									<Grid container>
										<Grid item xs={12} style={{padding: '0 0.5rem 1rem 0.5rem '}}>
											<Typography variant="button" style={{color: '#6b6565'}}>
												ARTICLE IMAGE
											</Typography>
											<Divider
												variant="inset"
												component="p"
												style={{width: '100%', marginLeft: '0px'}}
											/>
										</Grid>

										<Grid item xs={12} md={4} lg={4}>
											<Card>
												<CardActionArea>
													<img
														style={{
															width: '100%',
															maxHeight: state.articleImage ? 'unset' : '200px',
															objectFit: 'contain',
														}}
														alt="blank"
														src={state.articleImage || noimage}
													/>
													<CardContent>
														<Typography gutterBottom variant="h5" component="h2">
															Article Image
														</Typography>
														<Typography
															variant="body2"
															color="textSecondary"
															component="p"></Typography>
													</CardContent>
												</CardActionArea>
												<CardActions>
													<Grid container>
														<Grid item xs={12}>
															{/* <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={this.state.articleImageSelection}
                                                                            onChange={this.toggleArticleImageSelection}
                                                                            name="checkedB"
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="I want to Upload Image"
                                                                /> */}
														</Grid>
														<Grid item xs={12}>
															<Button
																size="small"
																color="primary"
																onClick={() =>
																	handlePerformCaptureImage(CAPTURE_IMAGE_OF_ARTICLE)
																}>
																<span>
																	{state.articleImage ? 'Re-' : ''}
																	{state.articleImageSelection
																		? 'Select Image'
																		: 'Capture'}
																</span>
															</Button>
															{/* {this.state.articleImage && (
                                                                    <Button size="small" color="primary" onClick={() => this.setState({ articleImage: null })}>Delete</Button>
                                                                )} */}
														</Grid>
													</Grid>
													{state.captureImageFor && (
														<ImageCapture
															id={state.captureImageFor}
															title={`Capture ${
																state.captureImageFor === CAPTURE_IMAGE_OF_SENDER
																	? 'Sender'
																	: 'Article'
															} Image`}
															show
															onClose={handleImageCapturePopupClose}
															onConfirm={handleImageCaptureResponse}
														/>
													)}
												</CardActions>
											</Card>
										</Grid>
									</Grid>
								</Paper>
							</Grid>

							{showPaymentOptions && (
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									lg={12}
									style={
										currentStep === 7 ? {padding: '0 1rem', display: 'initial'} : {display: 'none'}
									}>
									<Paper
										elevation={0}
										xs={12}
										sm={12}
										md={12}
										lg={12}
										style={{
											padding: '1rem',
											borderRadius: '6px',
											marginTop: '1rem',
										}}>
										<Grid container style={{gap: '1rem'}}>
											<Grid container direction="row">
												<Grid item xs={12} lg={6}>
													<Typography variant="h6">
														Amount to be paid: {RUPEE_SYMBOl}
														{
															// eslint-disable-next-line
															bookingConfig.paymentCollectType == '1' && fareRes
																? fareRes.totalAmount
																: bookingConfig.miniPickFareCollect
														}
													</Typography>
													{paymentOptionsError && (
														<Typography variant="subtitle2" color="error">
															{paymentOptionsError}
														</Typography>
													)}
												</Grid>
												{(!bookingConfig.paymentCollectType ||
													// eslint-disable-next-line
													bookingConfig.paymentCollectType != '1') && (
													<Grid item lg={6}>
														{fareRes && fareRes.paybleAmount && (
															<Typography>{`(Remaining amount tobe paid:${RUPEE_SYMBOl} ${
																fareRes.paybleAmount - bookingConfig.miniPickFareCollect
															})`}</Typography>
														)}
													</Grid>
												)}
											</Grid>

											{bookingConfig.paymentOptionList.map((item) => {
												if (item.isEnabled !== '1') return null;
												return (
													<Grid
														item
														xs={12}
														md={4}
														lg={4}
														className={`payment-type-item ${
															selectedPaymentOption &&
															selectedPaymentOption.topupType === item.topupType
																? 'active'
																: ''
														}`}
														onClick={() => {
															setSelectedPaymentOption(item);
															setPaymentOptionsError(null);
														}}
														style={{overflow: 'hidden', padding: '0'}}>
														<img
															height="80px"
															width="100%"
															style={{objectFit: 'contain'}}
															src={item.imageUrl}
															alt="payment"
														/>
													</Grid>
												);
											})}
										</Grid>
									</Paper>
								</Grid>
							)}
						</Grid>

						<Grid container spacing={2} style={{marginTop: 10}}>
							<Grid xs={12} style={{marginTop: 20, marginBottom: 20}}></Grid>
							<Grid item xs={12}>
								<Tabs
									selectedIndex={state.tabIndex}
									onSelect={(tabIndex) => setState((prev) => ({...prev, tabIndex}))}>
									{stateParams.addParams.map((addParam, index) =>
										addParam.type === 'tab' ? (
											<Tab style={{padding: 0}}>
												{handletabCount('Increament')}
												<Button
													variant="outlined"
													style={{
														borderColor: '#c5c5c5',
														borderBottomLeftRadius: 0,
														borderBottomRightRadius: 0,
														fontSize: 9,
														color:
															state.tabIndex === index - (index - count) - 1
																? '#FFFFFF'
																: '#000',
														backgroundColor:
															state.tabIndex === index - (index - count) - 1
																? '#477AB2'
																: '#FFFFFF',
													}}>
													{addParam.heading}
												</Button>
											</Tab>
										) : null
									)}
									<Grid item xs={12}>
										<Divider style={{width: '100%', marginBottom: 5}}></Divider>
									</Grid>

									{/* {this.state.showBooking ?
                                            <FareDetails handleFareCallback={this.handleFareCallback} url={this.props.url} weight={this.state.consigmentWeight} distanceResponse={this.state.distanceResponse} type={this.props.type} formData={this.state} table={{ "minWidth": "700" }} cargoTypeId={1} productTypeId={this.state.cargoTypeId} >
                                            </FareDetails>
                                         : null} */}
								</Tabs>
							</Grid>
						</Grid>

						{/* <Grid container justifyContent="center" alignContent="center" spacing={2}>
							{formValues.showBooking && !state.isLoading ? (
								<Grid item xs={12} md={6} lg={4} style={{marginBottom: '1rem'}}>
									<Button
										type="submit"
										fullWidth
										variant="contained"
										onClick={handleSubmit}
										disabled={
											state.isLoading || state.showRetryPopup || !fareRes || !fareRes.totalAmount
										}
										color="primary">
										{`Confirm ${APP_NAME}`}
									</Button>
								</Grid>
							) : null}

							{state.isLoading && <CircularProgress style={{marginTop: '1.5rem'}} />}
						</Grid> */}
						{/* {state.saveBookingResponse && state.loadPrint ? <BookingPrint bookingDetails={state.saveBookingResponse} /> : null} */}
						{handletabCount('Reset')}
						{state.shipmentAlert && (
							<BookingConfirmationDialog
								isOpen
								data={bookingConfirmationData}
								onClose={handleClose}
								showSnackbar={showSnackBar}
								submitDelay={parseInt(fareRes.delayTimeForbookingEnable) || 0}
							/>
						)}
						{state.isLoading && (
							<Grid container direction="column" justifyContent={'center'} alignItems={'center'}>
								<CircularProgress />
								<Typography>Loading...</Typography>
							</Grid>
						)}
						{state.bookingRes && state.bookingRes.id && (
							<Paper style={{padding: '1rem'}} id="booking-status">
								<Grid container alignItems="center" style={{marginBottom: '1rem'}}>
									<Grid item xs={12}>
										<Grid container>
											<CheckCircleIcon style={{color: 'green'}} />
											<Typography variant="body1">{`Thank you, your Shipment is Created Successfully from ${state.bookingRes.fromPlaceName} to ${state.bookingRes.toPlaceName} with`}</Typography>
										</Grid>
									</Grid>
									<Grid item xs={12}>
										<Typography
											id="awb-no"
											variant="h6"
											color="error">{`AWB number: ${state.bookingRes.id}`}</Typography>
									</Grid>
								</Grid>
								<Grid container justifyContent="center">
									<Button variant="contained" color="primary" onClick={handleBookAgain}>
										Book Again
									</Button>

									{/* {printViewFor === 1 ? <BookingTicketPrintFormat type="Parcel" bookingInfo={state.bookingRes} bookedByName={"Sample"} /> : <BookingStickersPrint data={state.bookingRes} />} */}
								</Grid>
							</Paper>
						)}
						{alertMessage && (
							<Dialog open fullWidth maxWidth="sm">
								<DialogContent>
									<DialogContentText>
										<strong>{alertMessage}</strong>
									</DialogContentText>
								</DialogContent>
								<DialogActions>
									<Button onClick={() => setAlertMessage('')} color="primary">
										OK
									</Button>
								</DialogActions>
							</Dialog>
						)}
						{state.showRetryPopup && (
							<Dialog open>
								<DialogTitle>Retry Booking</DialogTitle>
								<DialogContent>
									<DialogContentText>
										Error occurred while booking. Please try booking again.
									</DialogContentText>
								</DialogContent>
								<DialogActions>
									<Button
										onClick={() => {
											setState((prev) => ({...prev, showRetryPopup: false}));
										}}
										color="primary">
										Done
									</Button>
								</DialogActions>
							</Dialog>
						)}
						<input
							ref={articleImageUploadRef}
							id="articleImageInput"
							type="file"
							style={{display: 'none'}}
							onChange={handleImageSelect}
							accept="image/png, image/gif, image/jpeg"
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
});

export default withStyles(useStyles, {withTheme: true})(CustomerBookingForm);
